"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EKIPMAN_KONTROL_DURUMLARI = exports.equipmentUpdateSchema = exports.equipmentCreateSchema = exports.lookupItemDetailSchema = exports.personCompetencySummarySchema = exports.employmentSummarySchema = exports.personKimlikFullSchema = exports.personListSchema = exports.personDetailSchema = exports.lookupItemUpdateSchema = exports.lookupItemCreateSchema = exports.linkPersonSchema = exports.personImportPreviewSchema = exports.personImportPreviewRowSchema = exports.personImportReportSchema = exports.personImportRowResultSchema = exports.personImportRowStatusSchema = exports.personImportRequestSchema = exports.personImportRowSchema = exports.personCompetencyCreateSchema = exports.employmentUpdateSchema = exports.employmentCloseSchema = exports.employmentCreateSchema = exports.employmentBitisSebebiSchema = exports.personUpdateSchema = exports.personCreateSchema = exports.uyariEsigiGunSchema = exports.lookupListeKoduSchema = exports.maskeliKimlikNoSchema = exports.pasaportNoSchema = exports.yabanciKimlikSchema = exports.tcKimlikSchema = exports.KIMLIK_TIPI_ETIKETI = exports.kimlikTipiSchema = exports.locationNodeSummarySchema = exports.workplaceSummarySchema = exports.companyDetailSchema = exports.locationNodeCreateSchema = exports.workplaceUpdateSchema = exports.workplaceCreateSchema = exports.companyUpdateSchema = exports.companyCreateSchema = exports.bilinenNaceKodlari = exports.naceKodSchema = exports.hazardClassSchema = exports.tenantOverviewSchema = exports.authenticatedIdentitySchema = exports.dependencyStateSchema = exports.guncellemeSonucuSchema = exports.silmeSonucuSchema = void 0;
exports.roleScopeDetailSchema = exports.roleScopeCreateSchema = exports.roleScopeTypeSchema = exports.roleAssignmentCreateSchema = exports.roleTypeSchema = exports.selectablePersonnelSchema = exports.pendingUserSummarySchema = exports.contractorEkipmanSatiriSchema = exports.contractorPersonelSatiriSchema = exports.contractorDocumentAttachmentSchema = exports.contractorDocumentDetailSchema = exports.contractorDocumentYetkileriSchema = exports.contractorDocumentRejectSchema = exports.contractorDocumentUpdateSchema = exports.contractorDocumentCreateSchema = exports.contractorListSchema = exports.evrakBeklentisiSchema = exports.evrakBeklentiKalemiSchema = exports.yukleniciEvrakEkiCreateSchema = exports.yukleniciPaketAtamaSchema = exports.evrakPaketiMaliyetOzetiSchema = exports.evrakPaketleriSchema = exports.evrakPaketiSchema = exports.evrakPaketiKalemiSchema = exports.evrakPaketiOnizlemeGirdisiSchema = exports.evrakPaketiUpdateSchema = exports.evrakPaketiCreateSchema = exports.contractorDetailSchema = exports.contractorYetkileriSchema = exports.sahaGirisiSchema = exports.contractorUpdateSchema = exports.contractorCreateSchema = exports.EKIPMAN_KONTROL_DURUMU_ETIKETI = exports.EKIPMAN_YAKLASIYOR_GUN = exports.EKIPMAN_MARJ_GUN = exports.equipmentDurumGecisSchema = exports.equipmentInspectionSchema = exports.equipmentInspectionCreateSchema = exports.EKIPMAN_KONTROL_SONUCU_ETIKETI = exports.EKIPMAN_KONTROL_SONUCLARI = exports.EKIPMAN_KONTROL_YETKILISI_ETIKETI = exports.EKIPMAN_KONTROL_YETKILILERI = exports.equipmentImportReportSchema = exports.EKIPMAN_ICE_AKTARMA_SONUC_ETIKETI = exports.ekipmanIceAktarmaSonucSchema = exports.EKIPMAN_ICE_AKTARMA_SONUCLARI = exports.equipmentListSchema = exports.EKIPMAN_SAHIPLIGI_ETIKETI = exports.EKIPMAN_SAHIPLIKLERI = exports.equipmentDetailSchema = void 0;
exports.notificationBellSchema = exports.notificationBellItemSchema = exports.tenantSettingUpdateSchema = exports.tenantSettingsSchema = exports.assignableUserSchema = exports.nonconformityTransitionSchema = exports.nonconformityListSchema = exports.bildirimSonucuSchema = exports.nonconformityDetailSchema = exports.nonconformityDofOzetiSchema = exports.nonconformityYetkileriSchema = exports.incidentMoveToNonconformitySchema = exports.nonconformityMoveSchema = exports.nonconformityRejectSchema = exports.nonconformityCreateSchema = exports.nonconformityDurumSchema = exports.actionListSchema = exports.AKSIYON_NITELIK_ETIKETI = exports.actionDetailSchema = exports.actionYetkileriSchema = exports.actionReportDoneSchema = exports.actionCreateSchema = exports.actionImportReportSchema = exports.actionImportRowResultSchema = exports.AKSIYON_DEVIR_SONUC_ETIKETI = exports.aksiyonDevirSonucSchema = exports.AKSIYON_DEVIR_SONUCLARI = exports.RISK_AKSIYON_SAYILAN_DURUMLAR = exports.AKSIYON_CANLI_DURUMLAR = exports.AKSIYON_IZ_ETIKETI = exports.AKSIYON_IZ_ISLEMI = exports.actionTransitionSchema = exports.actionEditSchema = exports.actionTerminChangeSchema = exports.actionCancelSchema = exports.actionReassignSchema = exports.AKSIYON_DURUM_BEKLENTI_MESAJI = exports.actionDurumSchema = exports.kvkkConsentResultSchema = exports.kvkkConsentCreateSchema = exports.kvkkAydinlatmaSchema = exports.representativeAccountInviteSchema = exports.representativeAccountCreateSchema = exports.notificationDailyRunResultSchema = exports.myAuthorizationSchema = exports.appUserSummaryListSchema = exports.appUserSummarySchema = exports.appUserRoleSummarySchema = exports.appUserScopeSummarySchema = exports.roleAssignmentDetailSchema = void 0;
exports.contractorDocumentAttachmentContractIsInSync = exports.contractorListContractIsInSync = exports.contractorContractIsInSync = exports.equipmentInspectionContractIsInSync = exports.personListContractIsInSync = exports.equipmentListContractIsInSync = exports.equipmentContractIsInSync = exports.lookupItemContractIsInSync = exports.personCompetencyContractIsInSync = exports.employmentContractIsInSync = exports.personContractIsInSync = exports.locationNodeContractIsInSync = exports.workplaceContractIsInSync = exports.companyContractIsInSync = exports.tenantContractIsInSync = exports.identityContractIsInSync = exports.contractsAreInSync = exports.systemHealthSchema = exports.formSubmissionActionCreateSchema = exports.formSubmissionUpdateSchema = exports.FORM_GOREV_TURETILIR_MESAJI = exports.formSubmissionCreateSchema = exports.formSubmissionDetailSchema = exports.formSubmissionListSchema = exports.formDoldurmaHedefleriSchema = exports.formSubmissionSummarySchema = exports.formSubmissionAttachmentSchema = exports.formTemplateExcelIceAktarSonucSchema = exports.formVersionUpdateSchema = exports.formTemplateKapsamSchema = exports.formTemplateExcelIceAktarUyarisiSchema = exports.formTemplateExcelIceAktarGovdesiSchema = exports.formTemplateBahceliOlusturSchema = exports.formTemplateKapsamGirdisi = exports.formTemplateUpdateSchema = exports.formTemplateVersionDetailSchema = exports.formTemplateListSchema = exports.formTemplateSurumGecmisiSchema = exports.formTemplateSuzgecSchema = exports.formTemplateSummarySchema = exports.formSubmissionDurumSchema = exports.formVersionYayinDurumuSchema = exports.formTemplateDurumSchema = exports.actionAttachmentSchema = exports.DOSYA_TIP_MIME = exports.FORM_KAYIT_EK_LIMIT = exports.AKSIYON_EK_LIMIT = exports.DOSYA_MAX_BOYUT_BYTES = exports.notificationReadResultSchema = exports.notificationReadSchema = void 0;
exports.eksikIsyeriSchema = exports.eksikKisiSchema = exports.formSubmissionAttachmentContractIsInSync = exports.formSubmissionContractIsInSync = exports.formTemplateVersionContractIsInSync = exports.formTemplateContractIsInSync = exports.notificationReadResultContractIsInSync = exports.notificationBellContractIsInSync = exports.tenantSettingsContractIsInSync = exports.actionAttachmentContractIsInSync = exports.assignableUserContractIsInSync = exports.nonconformityContractIsInSync = exports.actionContractIsInSync = exports.kvkkConsentResultContractIsInSync = exports.kvkkAydinlatmaContractIsInSync = exports.notificationDailyRunContractIsInSync = exports.representativeAccountInviteContractIsInSync = exports.myAuthorizationContractIsInSync = exports.appUserSummaryContractIsInSync = exports.appUserRoleContractIsInSync = exports.appUserScopeContractIsInSync = exports.roleAssignmentContractIsInSync = exports.roleScopeContractIsInSync = exports.selectablePersonnelContractIsInSync = exports.pendingUserContractIsInSync = exports.personImportReportContractIsInSync = exports.contractorDocumentContractIsInSync = exports.contractorEkipmanContractIsInSync = exports.contractorPersonelContractIsInSync = void 0;
exports.deriveTehlikeSinifi = deriveTehlikeSinifi;
exports.getNaceSerh = getNaceSerh;
exports.isValidTcKimlik = isValidTcKimlik;
exports.makeTcKimlik = makeTcKimlik;
exports.parseKimlikNo = parseKimlikNo;
exports.maskeliKimlikNo = maskeliKimlikNo;
exports.readUyariEsigiGun = readUyariEsigiGun;
exports.deriveSonrakiKontrol = deriveSonrakiKontrol;
exports.ekipmanMarjSiniriUtc = ekipmanMarjSiniriUtc;
exports.ekipmanMarjSinirGunu = ekipmanMarjSinirGunu;
exports.ekipmanKontrolDurumu = ekipmanKontrolDurumu;
exports.ekipmanKontrolDurumuAraligi = ekipmanKontrolDurumuAraligi;
exports.aksiyonCanliMi = aksiyonCanliMi;
exports.aksiyonGecikmisMi = aksiyonGecikmisMi;
exports.ertelemeSayisi = ertelemeSayisi;
exports.riskAksiyonuSayilirMi = riskAksiyonuSayilirMi;
exports.riskMaddeTakibi = riskMaddeTakibi;
exports.aksiyonNiteligi = aksiyonNiteligi;
exports.sniffDosyaTipi = sniffDosyaTipi;
exports.dogrulaDosyaImza = dogrulaDosyaImza;
/**
 * @isg/validation — backend + web + (ileride) mobil ortak doğrulama kuralları.
 *
 * Neden ortak: bir iş kuralı (ör. bir iznin geçerlilik koşulu) tek yerde
 * yazılır, üç katman aynı kuralı çalıştırır (Teknoloji v1.0 §2.1).
 *
 * Faz 0 Session 1 kapsamı: yalnızca /health sözleşmesinin şeması.
 * Alan kuralları (PTW durum geçişleri, ekipman 1 gün marjı, risk seviyesi
 * eşiği) ilgili modül session'larında buraya eklenecek.
 */
const zod_1 = require("zod");
const shared_types_1 = require("@isg/shared-types");
// ⚠️ Dosyanın ÜSTÜNDE: CJS çıktısında `require` kaynak sırasıyla iner; şema
// tanımı (aşağıda) bu sabiti modül yüklenirken okur — altta dursaydı TDZ.
const contractor_1 = require("./contractor");
const kapi_durumu_1 = require("./kapi-durumu");
const nace_tehlike_sinifi_data_1 = require("./nace-tehlike-sinifi.data");
const form_schema_1 = require("./form-schema");
const risk_1 = require("./risk");
const kpi_1 = require("./kpi");
const egitim_1 = require("./egitim");
const gorev_1 = require("./gorev");
const vade_1 = require("./vade");
const ptw_kontrol_matrisi_1 = require("./ptw-kontrol-matrisi");
/**
 * YAZMA SÖZLEŞMESİ — GÖVDESİZ YANIT YOKTUR (F4·S5·B3, Kapsam §20.3b).
 *
 * Web istemcisi `apiSend` her yanıtı bir şemadan geçirir (§2.16 tip köprüsü);
 * `204 No Content` gövdesiz döndüğü için `response.json()` **SyntaxError**
 * fırlatır — `ApiError` bile değil. Ölçüldü (F4·S5·B3): risk maddesi UI'dan
 * silinince **kayıt sunucuda GİDİYOR ama satır ekranda KALIYOR** ve kullanıcı
 * hiçbir şey görmüyordu. Yani 204, "sessizce geçiliyor" değil, **başarılı
 * yıkıcı işlemi başarısız gösteriyordu.**
 *
 * KARAR: hiçbir uç 204 dönmez. Doğal bir yükü olan uç onu döner (tazelenmiş
 * detay/liste — `tasks/assignments` deseni), olmayan uç aşağıdaki iki asgari
 * gövdeden birini. Kilit `delete-contract.spec.ts`tedir: yeni bir 204 kırmızı
 * yanar.
 *
 * ⚠️ İstemci tarafında bu şemaları `z.unknown()` ile değiştirme — `unknown`
 * her şeyi kabul eder ve sözleşmenin bozulduğunu göremez (bugünkü körlüğün
 * ikinci yarısı tam buydu).
 */
exports.silmeSonucuSchema = zod_1.z.object({ silindi: zod_1.z.literal(true) });
exports.guncellemeSonucuSchema = zod_1.z.object({ guncellendi: zod_1.z.literal(true) });
exports.dependencyStateSchema = zod_1.z.enum(['up', 'down', 'not_configured']);
/**
 * GET /api/me — SSO'dan doğrulanmış kimlik. Rol/grup/izin alanı BİLİNÇLİ
 * olarak yok (kimlik ≠ yetki, Kapsam §4.4); buraya yetki alanı ekleyen
 * değişiklik yanlıştır. `sub` Keycloak kullanıcı uuid'i — denetim alanları
 * (created_by/updated_by) bu değeri yazar.
 */
exports.authenticatedIdentitySchema = zod_1.z.object({
    sub: zod_1.z.uuid().transform(shared_types_1.asUserId),
    preferredUsername: zod_1.z.string().min(1).optional(),
    email: zod_1.z.string().min(1).optional(),
    fullName: zod_1.z.string().min(1).optional(),
    // Broker alias'ı (madde 19) — yalnız eşleşme girdisi; tenant kararı
    // provisioning_rule'dadır, claim tek başına tenant seçmez.
    idpAlias: zod_1.z.string().min(1).optional(),
});
/**
 * GET /api/tenant — kullanıcının düştüğü tenant. Tenant SEÇTİREN alan
 * (tenant_id parametresi vb.) bilinçli olarak yok: tenant, sunucudaki
 * sub→app_user eşlemesinden gelir (Session 4). Buraya seçim alanı ekleyen
 * değişiklik yanlıştır.
 */
exports.tenantOverviewSchema = zod_1.z.object({
    id: zod_1.z.uuid().transform(shared_types_1.asTenantId),
    ad: zod_1.z.string().min(1),
    companies: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.uuid(),
        ad: zod_1.z.string().min(1),
    })),
});
// ── NACE → tehlike sınıfı (Kapsam §3.2, §8.5 — kilitli eşleme) ──────────────
//
// Tehlike sınıfı ELLE SEÇTİRİLMEZ; bu eşlemeyi biz sağlar ve kilitleriz,
// müşteriye girdirilmez. Tebliğ revizyonunda BİZ günceller ve etkilenen
// şirketleri sistem yeniden değerlendirir.
//
// TAM SET (F1·S9 — ERD §12/10 KAPANDI): RG-13/3/2025-32840 Ek-1'in 2114
// altılı kodu `nace-tehlike-sinifi.data.ts`te (üretilmiş dosya; kaynak kaydı
// ve yeniden üretim prosedürü başlığında, üretici `nace-generate.ts`).
// FAIL-LOUD aynen sürer: listede olmayan koda sınıf UYDURULMAZ — bilinmeyen
// kodla şirket açılamaz (Teknoloji §9: yanlış yeşil ışık, hiç yanmayan
// ışıktan tehlikelidir). NACE bir DB tablosu DEĞİLDİR (bilinçli, F1·S9):
// eşleme müşteri verisi değil kilitli ürün verisidir — lookup nüsha modeli
// (tenant'a kopya) düzenlenebilir sözlükler içindir; şerh dahil her alan
// koddan türetilir, kopyalanmaz (K4 deseni).
exports.hazardClassSchema = zod_1.z.enum(['low_risk', 'hazardous', 'highly_hazardous']);
/** NACE kodu biçimi: `NN.NN.NN` (tebliğ altılı kırılımı). */
exports.naceKodSchema = zod_1.z
    .string()
    .regex(/^\d{2}\.\d{2}\.\d{2}$/, 'NACE kodu NN.NN.NN biçiminde olmalı');
/**
 * NACE → tehlike sınıfı türetimi. FAIL-LOUD: eşlemede olmayan kod hata atar,
 * sınıf uydurmaz. API bu hatayı 400'e çevirir ("bilinmeyen NACE kodu").
 */
function deriveTehlikeSinifi(naceKod) {
    const sinif = nace_tehlike_sinifi_data_1.NACE_TEHLIKE_SINIFI[naceKod];
    if (!sinif) {
        throw new Error(`NACE kodu tehlike sınıfı eşlemesinde yok: ${naceKod}. ` +
            'Eşleme kilitlidir (Kapsam §8.5); kod tebliğ alt kümesine eklenmeden şirket açılamaz.');
    }
    return sinif;
}
/**
 * NACE şerhi ("Çok Tehlikeli *" dipnotu — KKDİK Ek-17 asbest yasağı atfı).
 * Şerh SINIFI DEĞİŞTİRMEZ (kod çok-tehlikeli kalır) ve DB'ye KOPYALANMAZ —
 * koddan türetilir (K4 deseni); şerhi olmayan kod için null.
 */
function getNaceSerh(naceKod) {
    return nace_tehlike_sinifi_data_1.NACE_SERH[naceKod] ?? null;
}
/** Eşlemede kayıtlı kodlar (test + form yardımcısı için salt okunur — tam set, 2114). */
exports.bilinenNaceKodlari = Object.keys(nace_tehlike_sinifi_data_1.NACE_TEHLIKE_SINIFI);
// ── Org master data sözleşmeleri (Faz 1 S1) ────────────────────────────────
//
// GİRDİ şemalarında tehlike_sinifi BİLİNÇLİ yok — sınıf türetilir, seçilmez.
// Çıktı şemaları AssertExact ile @isg/shared-types tiplerine kilitli.
// ✏️ F4·S3 (madde 83): NACE ŞİRKETTEN DÜŞTÜ, İŞYERİNE İNDİ. Fail-loud kural
// DEĞİŞMEDİ — yalnız uygulandığı birim değişti: listede olmayan NACE koduyla
// artık İŞYERİ açılamaz (eskiden şirket açılamazdı).
// Tarih alanları `YYYY-AA-GG` (date-only). GİRDİ şemaları API'nin kabul
// ettiğini, çıktı şemaları döndürdüğünü tanımlar; çıktılar AssertExact ile
// @isg/shared-types tiplerine kilitli.
const isoDate = zod_1.z.iso.date();
/**
 * ✏️ **TUR 9 / K7:** `sgkSicil` GİRDİ OLARAK KABUL EDİLMEZ. Şema `strict`
 * değildir ama alan yoksa değer yazılmaz; ucun kendisi de kolonu tanımıyor.
 * Sicilin evi işyeridir (`workplaceCreateSchema`).
 */
exports.companyCreateSchema = zod_1.z.object({
    ad: zod_1.z.string().trim().min(1),
});
exports.companyUpdateSchema = zod_1.z
    .object({
    ad: zod_1.z.string().trim().min(1).optional(),
})
    .refine((value) => Object.keys(value).length > 0, 'Güncellenecek alan yok');
exports.workplaceCreateSchema = zod_1.z.object({
    ad: zod_1.z.string().trim().min(1),
    sgkSicil: zod_1.z.string().trim().min(1),
    naceKod: exports.naceKodSchema,
    /** İ5: kısa süreli işyeri muafiyetinin sayacı. İsteğe bağlı — uydurulmaz. */
    faaliyetBaslangic: isoDate.nullish(),
});
exports.workplaceUpdateSchema = zod_1.z
    .object({
    ad: zod_1.z.string().trim().min(1).optional(),
    sgkSicil: zod_1.z.string().trim().min(1).optional(),
    naceKod: exports.naceKodSchema.optional(),
    faaliyetBaslangic: isoDate.nullable().optional(),
})
    .refine((value) => Object.keys(value).length > 0, 'Güncellenecek alan yok');
exports.locationNodeCreateSchema = zod_1.z.object({
    ad: zod_1.z.string().trim().min(1),
    tip: zod_1.z.enum(['permanent', 'temporary']),
    parentId: zod_1.z.uuid().nullish(),
    kot: zod_1.z.number().int().nullish(),
});
exports.companyDetailSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    ad: zod_1.z.string().min(1),
});
exports.workplaceSummarySchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    companyId: zod_1.z.uuid(),
    ad: zod_1.z.string().min(1),
    sgkSicil: zod_1.z.string().min(1),
    naceKod: zod_1.z.string().min(1),
    tehlikeSinifi: exports.hazardClassSchema,
    faaliyetBaslangic: zod_1.z.string().nullable(),
    /** TÜRETİLMİŞ sayı — kolon değildir (Kapsam §3.2). */
    calisanSayisi: zod_1.z.number().int().min(0),
    durum: zod_1.z.enum(['active', 'archived', 'suspended']),
});
exports.locationNodeSummarySchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    workplaceId: zod_1.z.uuid(),
    parentId: zod_1.z.uuid().nullable(),
    tip: zod_1.z.enum(['permanent', 'temporary']),
    ad: zod_1.z.string().min(1),
    kot: zod_1.z.number().int().nullable(),
    /** ✏️ ACİL DURUM (Kapsam §29/E4): toplanma noktası işareti — ağaca işaret, yeni kavram değil. */
    toplanmaNoktasi: zod_1.z.boolean(),
});
// ── Kişi ≠ istihdam + lookup sözleşmeleri (Faz 1 S2) ───────────────────────
//
// ── Kimlik ekseni (✅ karar 30.07.2026, Kapsam §18.1/P4-P5 — F1·S8) ─────────
//
// Kişi kimlik çapası `kimlik_no` + `kimlik_tipi`dir; e-posta YALNIZ hesap-eşleşme
// ekseni. Doğrulama derinliği tipe göre:
//   - tc             → 11 hane + ALGORİTMA (kontrol haneleri) — P5 ✅
//   - yabanci_kimlik → YALNIZ format (11 hane, 9 ile başlar): resmî algoritma
//                      kuralı DOĞRULANAMADI, uydurulmaz (ERD §3 şerhi)
//   - pasaport       → yalnız format (ülkeye göre değişir; harf+rakam)
// "Numara gerçekten bu kişiye mi ait" sorusu KPS/MERNİS işi — kapsam dışı
// (session-log madde 32).
exports.kimlikTipiSchema = zod_1.z.enum(['tc', 'yabanci_kimlik', 'pasaport']);
/**
 * Kimlik tipi Türkçe etiketi — **TEK KAYNAK** (`RISK_SEVIYESI_ETIKETI`
 * emsali, F4·S9). Ekran rozeti de, SUNUCUDA üretilen Excel çıktısı da bunu
 * okur; iki kopya tutulsaydı listede "T.C. kimlik" yazan hücre dosyada
 * "tc" olabilirdi.
 */
exports.KIMLIK_TIPI_ETIKETI = {
    tc: 'T.C. kimlik',
    yabanci_kimlik: 'Yabancı kimlik',
    pasaport: 'Pasaport',
};
/**
 * TC kimlik algoritması: ilk hane 0 olamaz; 10. hane = ((1,3,5,7,9. haneler
 * toplamı)×7 − (2,4,6,8. haneler toplamı)) mod 10; 11. hane = ilk 10 hanenin
 * toplamı mod 10. Yazım hatasını yakalar; kişiye aitliği KANITLAMAZ.
 */
function isValidTcKimlik(value) {
    if (!/^[1-9]\d{10}$/.test(value))
        return false;
    const d = [...value].map(Number);
    const tek = (d[0] ?? 0) + (d[2] ?? 0) + (d[4] ?? 0) + (d[6] ?? 0) + (d[8] ?? 0);
    const cift = (d[1] ?? 0) + (d[3] ?? 0) + (d[5] ?? 0) + (d[7] ?? 0);
    const hane10 = (((tek * 7 - cift) % 10) + 10) % 10;
    const hane11 = d.slice(0, 10).reduce((a, b) => a + b, 0) % 10;
    return d[9] === hane10 && d[10] === hane11;
}
/**
 * İlk 9 haneden geçerli 11 haneli TC üretir — TEST/SEED yardımcısı (koşuya
 * özgü doğal anahtar üretimi; gerçek kimlik üretmez, yazım kurallarını sağlar).
 */
function makeTcKimlik(firstNine) {
    if (!/^[1-9]\d{8}$/.test(firstNine)) {
        throw new Error('makeTcKimlik: ilk 9 hane, 0 ile başlamayan 9 rakam olmalı');
    }
    const d = [...firstNine].map(Number);
    const tek = (d[0] ?? 0) + (d[2] ?? 0) + (d[4] ?? 0) + (d[6] ?? 0) + (d[8] ?? 0);
    const cift = (d[1] ?? 0) + (d[3] ?? 0) + (d[5] ?? 0) + (d[7] ?? 0);
    const hane10 = (((tek * 7 - cift) % 10) + 10) % 10;
    const hane11 = (d.reduce((a, b) => a + b, 0) + hane10) % 10;
    return `${firstNine}${hane10}${hane11}`;
}
exports.tcKimlikSchema = zod_1.z
    .string()
    .regex(/^\d{11}$/, 'TC kimlik 11 rakam olmalı')
    .refine(isValidTcKimlik, 'TC kimlik algoritma kontrolünden geçmedi');
/** Yabancı kimlik: 11 hane, 9 ile başlar — YALNIZ format (algoritma şerhli). */
exports.yabanciKimlikSchema = zod_1.z
    .string()
    .regex(/^9\d{10}$/, 'Yabancı kimlik 9 ile başlayan 11 rakam olmalı');
/** Pasaport: harf+rakam, 5-16 karakter (büyük harfe normalize edilir). */
exports.pasaportNoSchema = zod_1.z
    .string()
    .trim()
    .regex(/^[A-Za-z0-9]{5,16}$/, 'Pasaport no 5-16 harf/rakam olmalı')
    .transform((value) => value.toUpperCase());
const KIMLIK_NO_SCHEMAS = {
    tc: exports.tcKimlikSchema,
    yabanci_kimlik: exports.yabanciKimlikSchema,
    pasaport: exports.pasaportNoSchema,
};
/** Tipe göre kimlik no doğrulaması — tek noktadan (üç giriş kanalı da bunu çağırır, P1). */
function parseKimlikNo(kimlikTipi, kimlikNo) {
    const result = KIMLIK_NO_SCHEMAS[kimlikTipi].safeParse(kimlikNo);
    if (result.success)
        return { success: true, data: result.data };
    return { success: false, message: result.error.issues[0]?.message ?? 'Kimlik no geçersiz' };
}
/**
 * Kimlik no MASKESİ — TEK NOKTA (✅ madde 37 kararı 05.08.2026, Kapsam
 * §18.1/10). Liste/kart yanıtları tam kimlik TAŞIMAZ: maske API kenarında
 * uygulanır, ekran maskeli alanı olduğu gibi gösterir. Tam değer sistemden
 * yalnız `GET /persons/:id/kimlik-full` ucundan (her gösterim loglu) çıkar.
 */
function maskeliKimlikNo(kimlikNo) {
    if (kimlikNo.length <= 4)
        return kimlikNo;
    return `${'•'.repeat(kimlikNo.length - 4)}${kimlikNo.slice(-4)}`;
}
/**
 * Maskeli biçim şeması — çıplak tam değer parse'da DÜŞER (negatif senaryo
 * kuralı: maskeyi unutan yanıt sessizce geçmez, kırmızı yanar).
 */
exports.maskeliKimlikNoSchema = zod_1.z
    .string()
    .regex(/^•+[A-Za-z0-9]{1,4}$/, 'Kimlik no maskeli olmalı (yalnız son 4 hane açık)');
exports.lookupListeKoduSchema = zod_1.z.enum([
    'yetkinlik_tipi',
    'yetki_tipi',
    'equipment_tip',
    'evrak_tipi',
    'olay_turu',
    'aksiyon_kaynagi',
    'izin_turu',
    'izin_gorevi',
    'geri_cekilme_gerekcesi',
    'kok_sebep',
    'kok_sebep_grubu',
    'olay_red_gerekcesi',
    'olay_kapanis_gerekcesi',
    'olay_sinifi',
    'olay_siddeti',
    'olay_aydinlatma',
    'olay_zemin',
    'yaralanma_turu',
    'vucut_bolgesi',
    'mekanizma',
    'yayilim_siniri',
    'madde_tehlike_sinifi',
    'egitim_turu',
    'egitim_konusu',
    'muayene_turu',
    'uygunluk_karari',
    'saglik_kisiti',
    'risk_tehlike',
    'risk_riski',
    // Tur 4 / K2 — ekipman kapasite birimi (ton · kg · m · bar · litre · m³ · kVA).
    'kapasite_birimi',
    'gorevlendirme_turu',
    // Tur 5 / İ1 — İBYS referans listeleri (BOŞ dağıtılır, doğrulanacak).
    'egitim_yeri',
    'sertifika_tipi',
    'egitim_yontemi_ibys',
    // Saha turu / S8 — denetlenen birim (müşteri sınıfı, kütüphanesiz).
    'denetlenen_birim',
    // KKD (Kapsam §30/Z2) — kalem listesi (müşteri sınıfı; kütüphane BOŞ, içerik ürün sahibinden).
    'kkd_kalemi',
]);
const kurallarSchema = zod_1.z.record(zod_1.z.string(), zod_1.z.unknown());
/**
 * Lookup kural şemasının BİLDİRİM anahtarı (Kapsam §22.2/3 — F2·S1, madde 25
 * bağı): `uyari_esigi_gun` — evrak/ekipman tipi kaleminde süre uyarısının kaç
 * gün önce başlayacağı. Nullable: anahtar yoksa motor varsayılanı (30) kullanır.
 * Kurallar jsonb'si opak/serbest kalır (Kapsam §19 — kural düzenleme tam
 * serbest); bu yalnız TANIMLI anahtarın okuma sözleşmesidir.
 */
exports.uyariEsigiGunSchema = zod_1.z.number().int().positive().nullable();
/**
 * `kurallar` jsonb'sinden bildirim eşiğini okur. Geçersiz değer (metin,
 * negatif, kesirli) null sayılır — kural düzenleme serbest olduğundan bozuk
 * bir kalem taramayı DÜŞÜRMEZ, o kalem varsayılan eşiğe döner (bilinçli
 * tolerans; motor tarafı varsayılanı uygular).
 */
function readUyariEsigiGun(kurallar) {
    if (typeof kurallar !== 'object' || kurallar === null || Array.isArray(kurallar))
        return null;
    const deger = kurallar['uyari_esigi_gun'];
    const parsed = exports.uyariEsigiGunSchema.safeParse(deger ?? null);
    return parsed.success ? parsed.data : null;
}
exports.personCreateSchema = zod_1.z
    .object({
    kimlikTipi: exports.kimlikTipiSchema,
    kimlikNo: zod_1.z.string().trim().min(1),
    /** SAP/İK kanalının ikinci ekseni (Kapsam §18.1/P4) — kimlik no ÇAPA kalır. */
    personelSicilNo: zod_1.z.string().trim().min(1).nullish(),
    adSoyad: zod_1.z.string().trim().min(1),
    dogumTarihi: isoDate,
    email: zod_1.z.email().toLowerCase().nullish(),
})
    .superRefine((value, ctx) => {
    const sonuc = parseKimlikNo(value.kimlikTipi, value.kimlikNo);
    if (!sonuc.success) {
        ctx.addIssue({ code: 'custom', path: ['kimlikNo'], message: sonuc.message });
    }
})
    .transform((value) => {
    const sonuc = parseKimlikNo(value.kimlikTipi, value.kimlikNo);
    return sonuc.success ? { ...value, kimlikNo: sonuc.data } : value;
});
/**
 * ✏️ **TUR 9 / K11 — KÜNYE DÜZENLEME (ürün sahibi kararı 05.09.2026).**
 * Bir kişinin adı yanlış girilmiş olabilir, e-postası değişir, sicili
 * sonradan gelir — bunlar için **silip yeniden açmak** doğru araç değildir
 * (silme yalnız hatalı kayıt düzeltme aracıdır, §18.1/D1).
 *
 * ⚠️ **KİMLİK NO VE TİPİ HARİÇTİR ve bu KİLİTLİ bir karardır.** Kimlik,
 * üç giriş kanalının (SSO provizyon · İK senkronu · toplu aktarma)
 * **eşleştirme ÇAPASIDIR** (§18.1/P4); değiştirilebilir olsaydı aynı dosya
 * bir kanalda A kişisi, diğerinde B kişisi olurdu. Yanlış kimlikle açılmış
 * dosyanın yolu **sil + yeniden aç**tır ve 409 zaten `restore` önerir.
 *
 * ⚠️ **DOĞUM TARİHİ DE HARİÇ** — ekranda gösterilmiyor (§2.16, S10 gezinti
 * kararı) ve düzenleme yüzeyi olmayan bir alana yazma ucu açmak, §2.40'ın
 * ters yönüdür (uç var, ekran yok).
 */
exports.personUpdateSchema = zod_1.z
    .object({
    adSoyad: zod_1.z.string().trim().min(1).optional(),
    personelSicilNo: zod_1.z.string().trim().min(1).nullable().optional(),
    email: zod_1.z.email().toLowerCase().nullable().optional(),
})
    .refine((value) => Object.keys(value).length > 0, 'Güncellenecek alan yok');
/** İstihdam kapanış sebebi (Kapsam §3.3b — madde 80). */
exports.employmentBitisSebebiSchema = zod_1.z.enum(['ayrilis', 'nakil']);
/**
 * ✏️ REVİZE F4·S3 (madde 80): istihdam TEK İŞYERİNE bağlanır — `workplaceId`
 * ZORUNLUDUR ve **şirket ondan TÜRETİLİR** (`companyId` girdiden DÜŞTÜ).
 * Alan nullable DEĞİL: *işyeri bilinmeyen çalışan yoktur* — boşluk belirsizlik
 * değil, veri girişi eksikliğidir (İ2).
 *
 * İŞVEREN XOR TEK KOLONDA: `contractorId` DOLU → işveren yüklenici firma;
 * BOŞ → işveren **işyerinin şirketi**. İki kolonlu XOR refine'ı (F1·S4)
 * gereksizleşti — kural artık ifade edilemez değil, ifadesi tek alanda.
 */
const employmentAlanlari = zod_1.z.object({
    workplaceId: zod_1.z.uuid(),
    contractorId: zod_1.z.uuid().nullish(),
    rol: zod_1.z.string().trim().min(1),
    baslangic: isoDate,
    bitis: isoDate.nullish(),
    bitisSebebi: exports.employmentBitisSebebiSchema.nullish(),
});
const BITIS_SIRASI = {
    kural: (v) => !v.bitis || v.bitis >= v.baslangic,
    mesaj: 'bitis, baslangic tarihinden önce olamaz',
};
const SEBEP_KAPANISTA = {
    kural: (v) => v.bitisSebebi == null || v.bitis != null,
    mesaj: 'Kapanış sebebi yalnız bitmiş istihdamda verilir',
};
exports.employmentCreateSchema = employmentAlanlari
    .refine(BITIS_SIRASI.kural, { message: BITIS_SIRASI.mesaj })
    .refine(SEBEP_KAPANISTA.kural, { message: SEBEP_KAPANISTA.mesaj });
/**
 * İSTİHDAM KAPANIŞI (madde 80 · İ13/İ14) — nakil bu uçtan geçer:
 * eski istihdam `nakil` sebebiyle KAPANIR, yeni istihdam ayrıca AÇILIR.
 * Sebep ZORUNLUDUR: sebebi boş kapanan kayıt ayrılış listelerinde
 * `<> nakil` süzgecinden geçer ve devir sayısını şişirir.
 */
exports.employmentCloseSchema = zod_1.z.object({
    bitis: isoDate,
    bitisSebebi: exports.employmentBitisSebebiSchema,
});
/**
 * ✏️ **TUR 9 / K11 — İSTİHDAM DÜZELTMESİ (T9-13).** Yalnız **rol** ve
 * **başlangıç tarihi**: ikisi de elle girilen ve yanlış girilebilen
 * alanlardır.
 *
 * ⚠️ **İŞYERİ VE İŞVEREN HARİÇTİR.** İşyerini değiştirmek bir düzeltme
 * değil bir **NAKİLDİR** (madde 80): eski istihdam `nakil` sebebiyle
 * KAPANIR, yeni istihdam AÇILIR — **geçmiş eski işyerinde kalır**. Bu ucu
 * işyerine açmak, o geçmişi sessizce taşırdı.
 * ⚠️ **BİTİŞ DE HARİÇ** — kapanışın kendi ucu vardır (`.../close`) ve sebep
 * orada ZORUNLUDUR; buradan bitiş yazmak sebepsiz kapanışa yol açardı.
 */
exports.employmentUpdateSchema = zod_1.z
    .object({
    rol: zod_1.z.string().trim().min(1).optional(),
    baslangic: isoDate.optional(),
})
    .refine((value) => Object.keys(value).length > 0, 'Güncellenecek alan yok');
exports.personCompetencyCreateSchema = zod_1.z
    .object({
    yetkinlikTipiId: zod_1.z.uuid(),
    gecerlilikBaslangic: isoDate,
    gecerlilikBitis: isoDate,
    belgeRef: zod_1.z.uuid().nullish(),
})
    // ✏️ K9 (tur 5): SIFIR GÜNLÜK GEÇERLİLİK REDDEDİLİR — bitiş başlangıçtan
    // SONRA olmalı (`>`); süresiz belge için bitiş boş bırakılır (eğitimden
    // doğan kayıt), elle yazılan yetkinlikte bitiş zorunludur. DB CHECK
    // `person_competency_gecerlilik_pozitif` aynı kuralın veri kilididir.
    .refine((value) => value.gecerlilikBitis > value.gecerlilikBaslangic, {
    message: 'Bitiş tarihi başlangıç tarihinden sonra olmalı (aynı gün geçerli sayılmaz)',
});
// ── Toplu aktarma (F1·S9 — Kapsam §18.1/P2) ────────────────────────────────
//
// Şablon = KİŞİ + İSTİHDAM (yüklenici personeli birincil senaryo; işveren
// şirket VEYA yüklenici — XOR employmentCreateSchema'dan gelir). Satır şeması
// mevcut tekil şemaların BİLEŞİMİDİR: kimlik doğrulaması personCreateSchema
// üzerinden parseKimlikNo'ya iner — kanal başına doğrulama YAZILMAZ (P1).
// Satır düzeyi hata istek düzeyine YÜKSELMEZ (kısmi başarı): istek şeması
// satırları z.unknown() alır, her satır motor tarafında tek tek parse edilir.
/**
 * ✏️ F4·S3 (madde 80): AKTARMA SATIRINDA İŞYERİ **DOĞAL ANAHTARLA** GELİR.
 * Dosya şablonu bir kolon taşır ("İşyeri SGK Sicil") ve uç onu tenant içinde
 * `workplaceId`ye çözer — istemciye işyeri LİSTELEYEN yeni bir okuma ucu
 * açılmadı (yüklenici portalının okuma yüzeyi genişlemez). Boş sicil satırı
 * REDDEDİLİR: NULL işyeri kabul edilmez (İ2).
 */
exports.personImportRowSchema = zod_1.z.object({
    kisi: exports.personCreateSchema,
    istihdam: employmentAlanlari
        .omit({ workplaceId: true })
        // Eksik ALAN ile boş DEĞER aynı cümleyi verir: satır raporunda kullanıcı
        // ikisini de "işyeri belirtilmemiş" olarak görür (D2 nötr dili).
        .extend({
        workplaceSgkSicil: zod_1.z
            .string({ error: 'İşyeri belirtilmemiş' })
            .trim()
            .min(1, 'İşyeri belirtilmemiş'),
    })
        .refine(BITIS_SIRASI.kural, { message: BITIS_SIRASI.mesaj })
        .refine(SEBEP_KAPANISTA.kural, { message: SEBEP_KAPANISTA.mesaj }),
});
/** v1 taşıma biçimi satır dizisidir (madde 20 dosya altyapısı yok — karar notu ERD'de). */
exports.personImportRequestSchema = zod_1.z.object({
    satirlar: zod_1.z.array(zod_1.z.unknown()).min(1).max(1000),
});
exports.personImportRowStatusSchema = zod_1.z.enum([
    'added',
    'new_employment',
    'unchanged',
    'restore_required',
    'error',
]);
exports.personImportRowResultSchema = zod_1.z.object({
    satir: zod_1.z.number().int().positive(),
    sonuc: exports.personImportRowStatusSchema,
    personId: zod_1.z.uuid().nullable(),
    mesaj: zod_1.z.string().nullable(),
});
exports.personImportReportSchema = zod_1.z.object({
    toplam: zod_1.z.number().int().nonnegative(),
    sayilar: zod_1.z.record(exports.personImportRowStatusSchema, zod_1.z.number().int().nonnegative()),
    satirlar: zod_1.z.array(exports.personImportRowResultSchema),
});
/**
 * TOPLU AKTARMA ÖNİZLEMESİ (F4·S9 — içe aktarma motoru).
 *
 * Dosya SUNUCUDA satırlara çevrilir ve **hiçbir şey yazılmadan** geri döner;
 * kullanıcı yükleyeceği listeyi onaylamadan önce görür. Önizleme
 * TARAYICIDA parse edilmez — parse'ın tek yeri motordur (kolon sırası iki
 * yerde yaşarsa sessizce kayar).
 *
 * ⚠️ **KİMLİK NO BURADA DA MASKELİ** (§2.16 — maske API kenarında): değer
 * kullanıcının kendi dosyasından gelse bile ağdan inen yanıta çıplak
 * yazılmaz. Satır İÇERİĞİ önizlemede DOĞRULANMAZ — hata dili tek kaynaktan,
 * yükleme raporundan gelir.
 */
exports.personImportPreviewRowSchema = zod_1.z.object({
    satir: zod_1.z.number().int().positive(),
    adSoyad: zod_1.z.string(),
    kimlikNoMaskeli: zod_1.z.string(),
    rol: zod_1.z.string(),
    baslangic: zod_1.z.string(),
});
exports.personImportPreviewSchema = zod_1.z.object({
    satirlar: zod_1.z.array(exports.personImportPreviewRowSchema),
});
/** Elle kişi↔hesap bağlama (bekleyenler listesi — Kapsam §18/3). */
exports.linkPersonSchema = zod_1.z.object({ personId: zod_1.z.uuid() });
/** Müşteri kalemi ekleme — kutuphaneRef GİRDİ DEĞİLDİR (nüsha yalnız dağıtımla açılır). */
exports.lookupItemCreateSchema = zod_1.z.object({
    ad: zod_1.z.string().trim().min(1),
    anaKalemId: zod_1.z.uuid().nullish(),
    kurallar: kurallarSchema.nullish(),
});
/**
 * Kalem düzenleme. `kurallar` TAM SERBEST — kütüphane nüshasında da (Kapsam
 * §19/7, şerhsiz). ad/anaKalemId yalnız müşteri kaleminde düzenlenir
 * (uygulama katmanı zorlar).
 */
exports.lookupItemUpdateSchema = zod_1.z
    .object({
    ad: zod_1.z.string().trim().min(1).optional(),
    anaKalemId: zod_1.z.uuid().nullable().optional(),
    kurallar: kurallarSchema.nullable().optional(),
    // Kapsam §19/9: nüsha silinemez, GİZLENİR — gizli kalem yeni referans
    // almaz, izinde seçilemez; mevcut kayıtlar yaşar. Nüshada da serbesttir
    // (gizleme kimlik değil, kullanım kararıdır).
    gizli: zod_1.z.boolean().optional(),
})
    .refine((value) => Object.keys(value).length > 0, 'Güncellenecek alan yok');
exports.personDetailSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    kimlikTipi: exports.kimlikTipiSchema,
    // Madde 37 (✅ 05.08.2026): liste/kart yanıtı MASKELİ alan taşır — tam
    // kimlik bu şemadan geçemez; tam değerin tek kapısı personKimlikFullSchema.
    kimlikNoMaskeli: exports.maskeliKimlikNoSchema,
    personelSicilNo: zod_1.z.string().nullable(),
    adSoyad: zod_1.z.string().min(1),
    /** Temsilci yanıtında NULL (TUR 6 / S8). */
    dogumTarihi: isoDate.nullable(),
    email: zod_1.z.string().nullable(),
});
/**
 * ✏️ **TUR 9 / B4 (T9-04) — SAYFALI ÇALIŞAN LİSTESİ.** Ekipman ucunun
 * (`equipmentListSchema`) birebir kardeşi: ekran sunucuda süzer, sunucuda
 * sayfalar ve **toplamı görünür kılar** (P4). ⚠️ Kişi kartı bu uçtan
 * beslenmez — onun ucu `GET persons/:id`dir (T9-03: kart 400 kayıt indirmez).
 */
exports.personListSchema = zod_1.z.object({
    satirlar: zod_1.z.array(exports.personDetailSchema),
    toplam: zod_1.z.number().int().nonnegative(),
    sayfa: zod_1.z.number().int().positive(),
    sayfaBoyutu: zod_1.z.number().int().positive(),
});
/**
 * Tam kimlik yanıtı (✅ madde 37 — GET /persons/:id/kimlik-full). Yalnız
 * holding yöneticisi + şirket yöneticisi (kendi bahçesi); her gösterim
 * person_identity_view_log'a yazılır (@isg/db readPersonKimlikFull).
 */
exports.personKimlikFullSchema = zod_1.z.object({
    personId: zod_1.z.uuid(),
    kimlikTipi: exports.kimlikTipiSchema,
    kimlikNo: zod_1.z.string().min(1),
});
exports.employmentSummarySchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    personId: zod_1.z.uuid(),
    workplaceId: zod_1.z.uuid(),
    /** TÜRETİLMİŞ alan (workplace.company_id) — kolon değildir. */
    companyId: zod_1.z.uuid().nullable(),
    contractorId: zod_1.z.uuid().nullable(),
    rol: zod_1.z.string().min(1),
    baslangic: isoDate,
    bitis: isoDate.nullable(),
    bitisSebebi: exports.employmentBitisSebebiSchema.nullable(),
});
exports.personCompetencySummarySchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    personId: zod_1.z.uuid(),
    yetkinlikTipiId: zod_1.z.uuid(),
    /** Kalemin adı SUNUCUDAN gelir (F4·S5·B4): eğitimden doğan yetkinliğin
     *  tipi `egitim_turu` kalemidir — ekran tek sözlük listesinden ad
     *  çözemez, ikinci bir istemci join'i yazılmaz. */
    yetkinlikTipiAd: zod_1.z.string(),
    /** TÜRETİLMİŞ vade durumu — eşik `resolveUyariEsigi`den, hesap sunucuda
     *  (`yetkinlikVadeDurumu`); ekran yalnız rozet ANLAMINA çevirir. */
    vadeDurumu: egitim_1.yetkinlikVadeDurumuSchema,
    gecerlilikBaslangic: isoDate,
    /** NULL = SÜRESİZ (F3B·S6): `suresiz` süre sınıflı eğitimden doğan
     *  yetkinlikte bitiş yoktur (§19/11-7). GİRDİ şeması
     *  (`personCompetencyCreateSchema`) DEĞİŞMEDİ — elle yazılan yetkinlikte
     *  bitiş hâlâ zorunludur; süresiz kayıt yalnız eğitim kaydından türer. */
    gecerlilikBitis: isoDate.nullable(),
    belgeRef: zod_1.z.uuid().nullable(),
});
exports.lookupItemDetailSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    listeKodu: exports.lookupListeKoduSchema,
    ad: zod_1.z.string().min(1),
    kutuphaneRef: zod_1.z.uuid().nullable(),
    anaKalemId: zod_1.z.uuid().nullable(),
    kurallar: kurallarSchema.nullable(),
    gizli: zod_1.z.boolean(),
});
// ── Ekipman master data (Faz 1 S3 — ERD §8 ✅ çekirdek) ────────────────────
//
// GİRDİ şemalarında sonrakiKontrol BİLİNÇLİ yok — türetilir, girilmez
// (tehlike_sinifi deseniyle aynı; Kapsam §16.5'in 1 gün marjı bu alanı okur,
// elle girilen değer marjı sessizce deler).
exports.equipmentCreateSchema = zod_1.z.object({
    ad: zod_1.z.string().trim().min(1),
    /** liste_kodu = equipment_tip kalemi — uygulama katmanı doğrular (400). */
    tipId: zod_1.z.uuid(),
    // ⚠️ PERİYOT KAYDIN ALANI DEĞİLDİR (91-1): kayıt SÜRE TAŞIMAZ, yalnız
    // TİPİNİ söyler. Kayda süre yazan kolon `sonraki_kontrol`ün eksenini ikiye
    // bölerdi — madde 91'in kapattığı hatanın birebir tekrarı.
    //
    // ✏️ **ARTÇI 1c (26.08.2026) — AŞAĞIDAKİ ALAN BİR İSTİSNA DEĞİL, İŞYERİ
    // KATMANINA GİDEN BİR EMİRDİR.** Ürün sahibi: *"işyerleri kendileri
    // yükler; yüklerken periyodu da belirlesinler."* Değer **KAYDA YAZILMAZ**;
    // `workplace_equipment_type_period` satırına gider ve o işyerindeki AYNI
    // TİPTEKİ TÜM ekipmanlar için geçerli olur (91-1: aynı işyerinde aynı tipe
    // iki farklı süre OLMAZ — farklı süre gerektiren ekipman farklı tiptir).
    //
    // ⚠️ Satır ZATEN VARSA gönderilmez: farklı bir değerle gelirse uç **409**
    // verir — ekleme formundan sessizce toplu vade değişikliği YAPILMAZ.
    kontrolPeriyoduAy: zod_1.z.number().int().positive().nullish(),
    /**
     * ✏️ **TUR 4 / K1: BU ARTIK BİR KÜNYE ALANI DEĞİL, BİR DEVİR BEYANIDIR.**
     * Değer `equipment.son_kontrol`e YAZILMAZ; **devir işaretli bir kontrol
     * kaydı** doğurur ve `son_kontrol` ondan TÜRETİLİR (§22.3/20 deseninin
     * ekipman kolu). Yapanı · sınıfı · raporu yoktur; beyan edilen tek şey
     * TARİHTİR ve kontrol geçmişinde **rozetle** görünür.
     *
     * ⚠️ **`PATCH equipment/:id`'DE BU ALAN YOKTUR** (aşağı bak): künye
     * ekranından tarih düzeltmek, kontrol geçmişini yalanlamak olurdu.
     */
    sonKontrol: isoDate.nullish(),
    locationId: zod_1.z.uuid().nullish(),
    // ── K2 — KÜNYE ALANLARI (07.08.2026 kararının kalanı) ───────────────────
    // SAHİPLİK: `contractorId` verilmezse sahip İŞYERİNİN ŞİRKETİDİR (sunucu
    // türetir). XOR'un iki kolu istemciden birlikte GÖNDERİLEMEZ.
    contractorId: zod_1.z.uuid().nullish(),
    seriNo: zod_1.z.string().trim().min(1).nullish(),
    demirbasNo: zod_1.z.string().trim().min(1).nullish(),
    imalatci: zod_1.z.string().trim().min(1).nullish(),
    imalatYili: zod_1.z.number().int().min(1900).max(2100).nullish(),
    kapasiteDeger: zod_1.z.number().positive().nullish(),
    kapasiteBirimId: zod_1.z.uuid().nullish(),
});
/**
 * ✏️ **TUR 4 / K1 — `sonKontrol` BU UÇTAN KAPANDI.**
 *
 * `son_kontrol` artık kontrol geçmişinden TÜRETİLİR (`sonraki_kontrol`in
 * zaten türetilmiş olması deseninin bir üst basamağı). Alan şemadan sessizce
 * ÇIKARILMADI — çıkarılsaydı zod onu **stripleyip** isteği kabul eder ve
 * kullanıcı *"kaydettim, değişmedi"* derdi (§2.40'ın S10 artçısındaki ölü
 * periyot alanı vakasının birebir tekrarı). Bunun yerine **fail-loud**:
 * alan gelirse 422 ve mesaj **ne yapılacağını** söyler.
 */
exports.equipmentUpdateSchema = zod_1.z
    .object({
    ad: zod_1.z.string().trim().min(1).optional(),
    tipId: zod_1.z.uuid().optional(),
    locationId: zod_1.z.uuid().nullable().optional(),
    contractorId: zod_1.z.uuid().nullable().optional(),
    seriNo: zod_1.z.string().trim().min(1).nullable().optional(),
    demirbasNo: zod_1.z.string().trim().min(1).nullable().optional(),
    imalatci: zod_1.z.string().trim().min(1).nullable().optional(),
    imalatYili: zod_1.z.number().int().min(1900).max(2100).nullable().optional(),
    kapasiteDeger: zod_1.z.number().positive().nullable().optional(),
    kapasiteBirimId: zod_1.z.uuid().nullable().optional(),
    sonKontrol: zod_1.z.unknown().optional(),
})
    .superRefine((value, ctx) => {
    if (value.sonKontrol !== undefined) {
        ctx.addIssue({
            code: 'custom',
            path: ['sonKontrol'],
            message: 'Son kontrol tarihi künyeden değiştirilemez — kontrol geçmişine bir kontrol kaydı ekleyin.',
        });
    }
    if (Object.keys(value).length === 0) {
        ctx.addIssue({ code: 'custom', message: 'Güncellenecek alan yok' });
    }
});
/** Ekipman kontrol durumunun dört değeri — anlamı `ekipmanKontrolDurumu` yorumunda. */
exports.EKIPMAN_KONTROL_DURUMLARI = ['bilinmiyor', 'marj', 'yaklasiyor', 'gecerli'];
exports.equipmentDetailSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    workplaceId: zod_1.z.uuid(),
    locationId: zod_1.z.uuid().nullable(),
    ad: zod_1.z.string().min(1),
    tipId: zod_1.z.uuid(),
    /// ⚠️ ÇÖZÜMLENEN periyot (AY) — KAYDIN ALANI DEĞİL, `resolveEkipmanPeriyoduAy`
    /// sonucudur (91-1/91-2). Tipinde de işyerinde de kural yoksa `null` ve
    /// `sonrakiKontrol` de null kalır (fail-loud; varsayılan UYDURULMAZ).
    kontrolPeriyoduAy: zod_1.z.number().int().positive().nullable(),
    sonKontrol: isoDate.nullable(),
    sonrakiKontrol: isoDate.nullable(),
    /// F4·S4/G5 — ekipman durumu. Pasif ekipman GÖREV ÜRETMEZ ve seçilebilir
    /// havuzlardan düşer; künyesi ise DÜZENLENEBİLİR KALIR (arşivden farkı).
    durum: zod_1.z.enum(['aktif', 'pasif']),
    /// G3/G6 — operasyonel kontrol izi. ⚠️ PERİYODİK tarihi İLERLETMEZ.
    sonOperasyonelKontrol: zod_1.z.string().nullable(),
    /// K10 — tip ADI SUNUCUDA çözülür (istemcide `find()` YOK).
    tipAd: zod_1.z.string(),
    /// K2 — sahiplik TEK KOLON (dolu = yüklenici) + künye.
    contractorId: zod_1.z.uuid().nullable(),
    seriNo: zod_1.z.string().nullable(),
    demirbasNo: zod_1.z.string().nullable(),
    imalatci: zod_1.z.string().nullable(),
    imalatYili: zod_1.z.number().int().nullable(),
    kapasiteDeger: zod_1.z.number().nullable(),
    kapasiteBirimId: zod_1.z.uuid().nullable(),
    kapasiteBirimAd: zod_1.z.string().nullable(),
    /// ✏️ MADDE 302 — kontrol durumu SUNUCUDAN (saha günü; ekran tarayıcı gününü okumaz).
    kontrolDurumu: zod_1.z.enum(exports.EKIPMAN_KONTROL_DURUMLARI),
});
/**
 * **SAHİPLİK SÜZGECİ (tur 4 artçısı / Y3).** K2'nin *"sahiplik TEK KOLON"*
 * kararının süzgeç karşılığı: `contractorId` dolu = yüklenici ekipmanı, boş =
 * işyerinin şirketinin. İkinci bir kolon yok, bu yüzden süzgeç de iki
 * değerlidir — "her ikisi" ayrı bir değer DEĞİL, süzgecin yokluğudur.
 */
exports.EKIPMAN_SAHIPLIKLERI = ['kendi', 'yuklenici'];
exports.EKIPMAN_SAHIPLIGI_ETIKETI = {
    kendi: 'İşyerinin şirketi',
    yuklenici: 'Yüklenici',
};
/**
 * P4 — SAYFALANMIŞ EKİPMAN LİSTESİ (tur 4 artçısı / Y3; `formSubmissionList`
 * deseni). `toplam` HER ZAMAN döner: çıktı motorunun cümlesi (*"şu anki
 * süzgeçle N kayıt"*) ancak böyle net olur.
 *
 * ⚠️ **İSTEMCİ SAYFALAMASI KALKTI:** envanter modülün en kalabalık listesidir
 * ve tarayıcıya bahçenin tamamını indirmek, süzgeci de sayfalamayı da
 * *"yüklendikten sonra"* çalışan bir süse çevirirdi.
 */
exports.equipmentListSchema = zod_1.z.object({
    satirlar: zod_1.z.array(exports.equipmentDetailSchema),
    toplam: zod_1.z.number().int().nonnegative(),
    sayfa: zod_1.z.number().int().positive(),
    sayfaBoyutu: zod_1.z.number().int().positive(),
});
/**
 * **EKİPMAN TOPLU YÜKLEME RAPORU (tur 4 artçısı / Y4).** Kısmi başarı satır
 * düzeyindedir: bozuk satır isteği düşürmez.
 *
 * ⚠️ **UYARI ≠ HATA** (devir raporu deseni): satır işlendiği hâlde beyanla
 * sistem arasında bir fark oluştuysa (periyot kuralı hiçbir katmanda yok →
 * vade hesaplanamadı) satır `uyarilar` taşır. Hataya çevirmek envanterin
 * yüklenmesini engellerdi; sessizce yutmak *"vade neden boş"* sorusunu
 * kullanıcının kendi başına keşfetmesine bırakırdı.
 */
exports.EKIPMAN_ICE_AKTARMA_SONUCLARI = ['eklendi', 'hata'];
exports.ekipmanIceAktarmaSonucSchema = zod_1.z.enum(exports.EKIPMAN_ICE_AKTARMA_SONUCLARI);
exports.EKIPMAN_ICE_AKTARMA_SONUC_ETIKETI = {
    eklendi: 'Eklendi',
    hata: 'İşlenemedi',
};
exports.equipmentImportReportSchema = zod_1.z.object({
    toplam: zod_1.z.number().int().min(0),
    eklenen: zod_1.z.number().int().min(0),
    hatali: zod_1.z.number().int().min(0),
    satirlar: zod_1.z.array(zod_1.z.object({
        satir: zod_1.z.number().int().positive(),
        sonuc: exports.ekipmanIceAktarmaSonucSchema,
        /** Eklenen satırda ekipmanın adı; hatalı satırda null. */
        ad: zod_1.z.string().nullable(),
        mesaj: zod_1.z.string().nullable(),
        uyarilar: zod_1.z.array(zod_1.z.string()),
    })),
});
/* ═══ EKİPMAN KONTROL GEÇMİŞİ (tur 4 / K1 — Kapsam §16.5, ERD §8) ═══════════
 *
 * **`equipment.son_kontrol` BU KAYITLARDAN TÜRETİLİR.** Türetme kuralı
 * `@isg/db refreshEkipmanSonKontrolTx`tedir; buradaki şemalar yalnız
 * sözleşmeyi taşır.
 */
exports.EKIPMAN_KONTROL_YETKILILERI = [
    'yetkin_kisi',
    'belgeli_kisi',
    'yetkili_kurulus',
    'kullanici',
];
/** Ekranda ve ÇIKTIDA aynı kelime kullanılsın diye tek yerde (S9 dersi). */
exports.EKIPMAN_KONTROL_YETKILISI_ETIKETI = {
    yetkin_kisi: 'Yetkin kişi',
    belgeli_kisi: 'Belgeli kişi',
    yetkili_kurulus: 'Yetkili kuruluş',
    kullanici: 'Kullanıcı',
};
exports.EKIPMAN_KONTROL_SONUCLARI = ['uygun', 'uygun_degil'];
exports.EKIPMAN_KONTROL_SONUCU_ETIKETI = {
    uygun: 'Uygun',
    uygun_degil: 'Uygun değil',
};
/**
 * ⚠️ **KONTROLÜ YAPAN TEKİLDİR** — kişi VEYA dış kuruluş adı, tam olarak
 * biri (DB CHECK `equipment_inspection_yapan_tekil` ile de kilitli).
 * *Sahipsiz kontrol kaydı, kaydın kendisini kanıtsız bırakır.*
 *
 * ⚠️ **`kontrolYetkilisi` GÖVDEDE YOKTUR ve bu bilinçli:** sınıf ekipman
 * TİPİNİN kuralından çözülür (§19/11-4) — kullanıcı seçseydi, kural iki
 * yerde yaşar ve *"bu tipin kontrolünü kim yapabilir"* sorusunun cevabı
 * kayıttan kayda değişirdi.
 */
exports.equipmentInspectionCreateSchema = zod_1.z
    .object({
    kontrolTarihi: isoDate,
    yapanPersonId: zod_1.z.uuid().nullish(),
    yapanKurulus: zod_1.z.string().trim().min(1).nullish(),
    sonuc: zod_1.z.enum(exports.EKIPMAN_KONTROL_SONUCLARI),
    notMetni: zod_1.z.string().trim().min(1).max(2000).nullish(),
})
    .superRefine((value, ctx) => {
    const sayi = [value.yapanPersonId, value.yapanKurulus].filter((deger) => deger !== null && deger !== undefined).length;
    if (sayi !== 1) {
        ctx.addIssue({
            code: 'custom',
            path: ['yapanPersonId'],
            message: 'Kontrolü yapan olarak ya bir kişi ya da bir dış kuruluş seçilmeli.',
        });
    }
});
exports.equipmentInspectionSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    equipmentId: zod_1.z.uuid(),
    kontrolTarihi: isoDate,
    kontrolYetkilisi: zod_1.z.enum(exports.EKIPMAN_KONTROL_YETKILILERI).nullable(),
    yapanPersonId: zod_1.z.uuid().nullable(),
    yapanAd: zod_1.z.string().nullable(),
    yapanKurulus: zod_1.z.string().nullable(),
    sonuc: zod_1.z.enum(exports.EKIPMAN_KONTROL_SONUCLARI),
    notMetni: zod_1.z.string().nullable(),
    raporDosyaId: zod_1.z.uuid().nullable(),
    raporDosyaAdi: zod_1.z.string().nullable(),
    formSubmissionId: zod_1.z.uuid().nullable(),
    devirMi: zod_1.z.boolean(),
    createdAt: zod_1.z.string(),
});
/**
 * Ekipman durum geçişi (F4·S4/Z7) — `workplace` arşiv geçişinin ikizi, TEK
 * FARKI **gerekçenin ZORUNLU** olması (DB CHECK ile de kilitli): pasife alma
 * gerekçesiz yapılamaz, çünkü açık görevleri `gecersiz` kapatan bir işlem
 * geriye dönük olarak "neden" sorusunu doğurur.
 */
exports.equipmentDurumGecisSchema = zod_1.z.object({
    durum: zod_1.z.enum(['aktif', 'pasif']),
    gerekce: zod_1.z.string().trim().min(1),
});
/**
 * sonraki_kontrol TÜRETME KURALI (ERD §8): **son_kontrol + ÇÖZÜMLENEN PERİYOT.**
 * TEK kaynak burasıdır — API yazarken bunu çağırır, PTW 1 gün marjını
 * (`sonraki_kontrol > now() + 1 gün`, Kapsam §16.5) bu alanın üstünde işletir.
 *
 * ✏️ **26.08.2026 (91-1): GİRDİSİ DEĞİŞTİ, KURALI DEĞİŞMEDİ.**
 * ~~`son_kontrol + kontrol_periyodu_gun` (KAYIT, birim GÜN)~~ →
 * **`son_kontrol + periyotAy` (TİPTEN ÇÖZÜMLENEN, birim AY).** Ay ekleme
 * `ayEkleUtc` ile (`+n month`) — **artık yıl kayması yok**; 3650 gün ile
 * 120 ay artık farklı tarihler vermez, çünkü **ikinci eksen kalmadı.**
 * Türetilmişlik, 1 gün marjı ve fail-loud davranış **aynen.**
 *
 * **İKİ FAIL-LOUD KOLU, AYNI SONUÇ (null):**
 *   · `son_kontrol` yok → kontrol tarihi bilinmiyor,
 *   · `periyotAy` null → **tipinde de işyerinde de kural yok**
 *     (sınıflandırılmamış / müşteri kalemi / kural boş).
 * Sistem her iki hâlde de o ekipmana *"uygundur" DEMEZ*; **varsayılan
 * periyot UYDURULMAZ** (Yönerge §5).
 *
 * Tarih aritmetiği UTC gün ekseninde (date-only; saat dilimi kaymaz).
 */
function deriveSonrakiKontrol(sonKontrol, periyotAy) {
    if (periyotAy === null)
        return null;
    if (!Number.isInteger(periyotAy) || periyotAy <= 0) {
        throw new Error(`kontrol_periyodu_ay pozitif tam sayı olmalı: ${periyotAy}`);
    }
    if (sonKontrol === null)
        return null;
    const parsed = isoDate.safeParse(sonKontrol);
    if (!parsed.success) {
        throw new Error(`son_kontrol YYYY-AA-GG biçiminde olmalı: ${JSON.stringify(sonKontrol)}`);
    }
    return (0, gorev_1.ayEkleUtc)(new Date(`${sonKontrol}T00:00:00.000Z`), periyotAy)
        .toISOString()
        .slice(0, 10);
}
/** Marj sınırı: kontrolün iznin ORTASINDA dolmasını baştan engeller (§16.5). */
exports.EKIPMAN_MARJ_GUN = 1;
/** Uyarı penceresi — kapı değil, görünürlük. */
exports.EKIPMAN_YAKLASIYOR_GUN = 30;
function gunEkleUtc(gun, ekle) {
    const tarih = new Date(`${gun}T00:00:00.000Z`);
    tarih.setUTCDate(tarih.getUTCDate() + ekle);
    return tarih.toISOString().slice(0, 10);
}
/**
 * **1 GÜN MARJININ SINIRI — TEK FONKSİYON (K7, tur 4).**
 *
 * `sonraki_kontrol > ekipmanMarjSiniriUtc()` olan ekipman izinde seçilebilir.
 * Sınırın kendisi bir gün BAŞIDIR (`@db.Date` ekseni — UTC gece yarısı);
 * karşılaştırma tarafları aynı eksene oturmadan `>` operatörü saatlere göre
 * kayar.
 *
 * ✏️ MADDE 298 (30.09.2026): **"bugün" SAHA GÜNÜDÜR** (`yerelGun` —
 * `vade.ts`). Girdi bir ANdır; eskiden günü UTC'den okuyordu ve Türkiye'de
 * 00:00–03:00 arasında marj DÜNE göre kuruluyor, yarın kontrolü dolacak
 * ekipman üç saat daha izinde seçilebiliyordu. ⚠️ Yalnız saat kaynağı değişti:
 * marj hâlâ 1 gündür, sınır hâlâ `>`dir. Gün dizgisiyle çalışan okuyucu
 * `ekipmanMarjSinirGunu`nu çağırır — ikisi aynı sabiti okur.
 *
 * ⚠️ **ÜÇ OKUYUCU BUNU ÇAĞIRIR:** `ekipmanKontrolDurumu` (ekran rozeti +
 * çıktı süzgeci) · `@isg/db` uygunluk motorunun ekipman bacağı · PTW talep
 * formunun ekipman havuzu sorgusu. Her biri sınırı **kendi elleriyle**
 * kuruyordu (`setUTCDate(+1)` üç ayrı yerde) ve **dördüncü bir sabit**
 * `ptw.ts`te ölü duruyordu — marjı değiştirmek dört dosyaya dokunmak
 * demekti; biri unutulduğunda **hiçbir hata mesajı olmaz, yalnız iki farklı
 * sınır vardır.**
 */
function ekipmanMarjSiniriUtc(simdi = new Date()) {
    return new Date(`${ekipmanMarjSinirGunu((0, vade_1.yerelGun)(simdi))}T00:00:00.000Z`);
}
/** Marj sınırının GÜN hâli — girdi saha günüdür (`YYYY-AA-GG`). */
function ekipmanMarjSinirGunu(bugun) {
    return gunEkleUtc(bugun, exports.EKIPMAN_MARJ_GUN);
}
function ekipmanKontrolDurumu(sonrakiKontrol, bugun) {
    if (!sonrakiKontrol)
        return 'bilinmiyor';
    // K7 — sınır TEK FONKSİYONDAN; gün ekseninde ISO karşılaştırması.
    if (sonrakiKontrol <= ekipmanMarjSinirGunu(bugun))
        return 'marj';
    if (sonrakiKontrol <= gunEkleUtc(bugun, exports.EKIPMAN_YAKLASIYOR_GUN))
        return 'yaklasiyor';
    return 'gecerli';
}
function ekipmanKontrolDurumuAraligi(durum, bugun) {
    const marjSiniri = ekipmanMarjSinirGunu(bugun);
    const yaklasiyorSiniri = gunEkleUtc(bugun, exports.EKIPMAN_YAKLASIYOR_GUN);
    switch (durum) {
        case 'bilinmiyor':
            return { tip: 'bilinmiyor' };
        case 'marj':
            return { tip: 'aralik', gtGun: null, lteGun: marjSiniri };
        case 'yaklasiyor':
            return { tip: 'aralik', gtGun: marjSiniri, lteGun: yaklasiyorSiniri };
        case 'gecerli':
            return { tip: 'aralik', gtGun: yaklasiyorSiniri, lteGun: null };
    }
}
exports.EKIPMAN_KONTROL_DURUMU_ETIKETI = {
    bilinmiyor: 'Kontrol tarihi bilinmiyor',
    marj: 'Kontrole ≤1 gün — izinde seçilemez',
    yaklasiyor: 'Kontrol yaklaşıyor',
    gecerli: 'Geçerli',
};
// ── Yüklenici master data (Faz 1 S4 — ERD §8 ✅ çekirdek; TUR 6 künye + eksen) ─
//
// Yüklenici FİRMA kaydı; personeli person + employment.contractorId deseni
// taşır (işveren XOR — yukarıda). ⚠️ `sahaGirisOnay` GİRDİ DEĞİLDİR ve
// yanıtta KOLON DEĞİLDİR (TUR 6 / Ş2): saha girişi `sahaGirisiTuret`ten
// türetilir (contractor.ts); uç bu anahtarı gövdede görürse 422 (D2 dili).
const kunyeAlanlari = {
    vergiNo: zod_1.z.string().trim().min(1).max(32).nullish(),
    yetkiliAd: zod_1.z.string().trim().min(1).nullish(),
    yetkiliTel: zod_1.z.string().trim().min(1).max(32).nullish(),
    yetkiliEposta: zod_1.z.email().toLowerCase().nullish(),
    sozlesmeBaslangic: isoDate.nullish(),
    /** NULL = SABİT ALT İŞVEREN (Kapsam §5.13/9). */
    sozlesmeBitis: isoDate.nullish(),
    /** BİLGİ alanı — yetki taşımaz (Ş3). */
    sorumluPersonId: zod_1.z.uuid().nullish(),
};
function sozlesmeTutarli(value) {
    return (!value.sozlesmeBaslangic ||
        !value.sozlesmeBitis ||
        value.sozlesmeBitis >= value.sozlesmeBaslangic);
}
exports.contractorCreateSchema = zod_1.z
    .object({
    ad: zod_1.z.string().trim().min(1),
    /** 🔶 Bugün serbest alan (ERD §12/15); değerlendirme akışı v2. */
    degerlendirmeSkoru: zod_1.z.number().min(0).max(100).nullish(),
    ...kunyeAlanlari,
    /**
     * K-102b (17.09.2026): her yüklenicinin evrak paketi VARDIR — seçim
     * zorunlu, varsayılan atanmaz (sessiz boşluk açılmaz).
     */
    evrakPaketiId: zod_1.z.uuid({ message: 'Evrak paketi seçilmeli' }),
})
    .refine(sozlesmeTutarli, { message: 'Sözleşme bitişi başlangıçtan önce olamaz' });
exports.contractorUpdateSchema = zod_1.z
    .object({
    ad: zod_1.z.string().trim().min(1).optional(),
    degerlendirmeSkoru: zod_1.z.number().min(0).max(100).nullable().optional(),
    ...kunyeAlanlari,
})
    .refine((value) => Object.keys(value).length > 0, 'Güncellenecek alan yok');
exports.sahaGirisiSchema = zod_1.z.object({
    gecerli: zod_1.z.boolean(),
    nedenler: zod_1.z.array(zod_1.z.object({
        evrakTipiId: zod_1.z.uuid(),
        evrakTipiAd: zod_1.z.string(),
        eksen: zod_1.z.enum(['firma', 'kisi']),
        // ✏️ K-102h: `dosya_bos` DÜŞTÜ (boş dosya freni kalktı).
        durum: zod_1.z.enum(['eksik', 'suresi_dolmus', 'bekliyor', 'reddedildi']),
        /** K-102g: beklenen (paket · ek) ya da dosyada sunulmuş diğer tip. */
        kaynak: zod_1.z.enum(['paket', 'ek', 'sunulmus']),
        personId: zod_1.z.uuid().nullable(),
    })),
});
exports.contractorYetkileriSchema = zod_1.z.object({
    kunyeYazabilir: zod_1.z.boolean(),
    evrakYukleyebilir: zod_1.z.boolean(),
    /** P13 — evrak yazma kapısı (şapka → temsilcide firma bahçesi) + sebep. */
    evrakKapisi: kapi_durumu_1.kapiDurumuSchema,
    kararVerebilir: zod_1.z.boolean(),
    davetAcabilir: zod_1.z.boolean(),
    silebilir: zod_1.z.boolean(),
    /** K-102j — paket atama + özel ek kapısı (holding + şirket yön.) + sebep. */
    paketKapisi: kapi_durumu_1.kapiDurumuSchema,
});
exports.contractorDetailSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    ad: zod_1.z.string().min(1),
    degerlendirmeSkoru: zod_1.z.number().min(0).max(100).nullable(),
    vergiNo: zod_1.z.string().nullable(),
    yetkiliAd: zod_1.z.string().nullable(),
    yetkiliTel: zod_1.z.string().nullable(),
    yetkiliEposta: zod_1.z.string().nullable(),
    sozlesmeBaslangic: isoDate.nullable(),
    sozlesmeBitis: isoDate.nullable(),
    sozlesmeDurumu: zod_1.z.enum(['sabit', 'suren', 'bitmis']),
    sorumluPersonId: zod_1.z.uuid().nullable(),
    sorumluPersonAd: zod_1.z.string().nullable(),
    /** TÜRETİLMİŞ (Ş2) — kolon yok, ekran hesaplamaz. */
    sahaGirisi: exports.sahaGirisiSchema,
    /** K-102b — her yüklenicinin paketi vardır. */
    evrakPaketi: zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string().min(1) }),
    /** SUNUCUDAN (aksiyon deseni) — ekranda rol listesi kopyası YOK (K4). */
    yetkiler: exports.contractorYetkileriSchema,
});
// ── YÜKLENİCİ EVRAK PAKETİ (K-102a…k — 17.09.2026; Kapsam §5.13/15) ─────────
const evrakTipiIdListesi = zod_1.z
    .array(zod_1.z.uuid())
    .refine((ids) => new Set(ids).size === ids.length, 'Aynı evrak tipi iki kez seçilemez');
exports.evrakPaketiCreateSchema = zod_1.z.object({
    ad: zod_1.z.string().trim().min(1, 'Paket adı boş olamaz'),
    /** Boş dizi serbest (K-102h — boş beklenti de bir beklentidir). */
    evrakTipiIds: evrakTipiIdListesi,
});
exports.evrakPaketiUpdateSchema = zod_1.z
    .object({
    ad: zod_1.z.string().trim().min(1, 'Paket adı boş olamaz').optional(),
    evrakTipiIds: evrakTipiIdListesi.optional(),
})
    .refine((value) => Object.keys(value).length > 0, 'Güncellenecek alan yok');
exports.evrakPaketiOnizlemeGirdisiSchema = zod_1.z.object({ evrakTipiIds: evrakTipiIdListesi });
exports.evrakPaketiKalemiSchema = zod_1.z.object({
    evrakTipiId: zod_1.z.uuid(),
    evrakTipiAd: zod_1.z.string(),
    eksen: zod_1.z.enum(['firma', 'kisi']),
});
exports.evrakPaketiSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    ad: zod_1.z.string().min(1),
    kalemler: zod_1.z.array(exports.evrakPaketiKalemiSchema),
    yukleniciSayisi: zod_1.z.number().int().nonnegative(),
});
exports.evrakPaketleriSchema = zod_1.z.array(exports.evrakPaketiSchema);
/**
 * MALİYET ÖZETİ (K-102e) — değiştirmeden ÖNCE sonucu göster. Sayılar
 * `sahaGirisiTuret`in eski ve yeni kümeyle İKİ koşusundan gelir (ikinci hesap
 * yolu yok). `yeniIstenenEvrakSayisi` = yeni kümeye giren ve sahayı açan
 * kaydı OLMAYAN (kalem × firma/kişi) çifti.
 */
exports.evrakPaketiMaliyetOzetiSchema = zod_1.z.object({
    yukleniciSayisi: zod_1.z.number().int().nonnegative(),
    girisKaybedenFirmaSayisi: zod_1.z.number().int().nonnegative(),
    girisKaybedenKisiSayisi: zod_1.z.number().int().nonnegative(),
    girisKazananKisiSayisi: zod_1.z.number().int().nonnegative(),
    yeniIstenenEvrakSayisi: zod_1.z.number().int().nonnegative(),
    dusenKalemler: zod_1.z.array(zod_1.z.string()),
    eklenenKalemler: zod_1.z.array(zod_1.z.string()),
});
exports.yukleniciPaketAtamaSchema = zod_1.z.object({ evrakPaketiId: zod_1.z.uuid() });
exports.yukleniciEvrakEkiCreateSchema = zod_1.z.object({ evrakTipiId: zod_1.z.uuid() });
exports.evrakBeklentiKalemiSchema = zod_1.z.object({
    evrakTipiId: zod_1.z.uuid(),
    evrakTipiAd: zod_1.z.string(),
    eksen: zod_1.z.enum(['firma', 'kisi']),
    kaynak: zod_1.z.enum(['paket', 'ek']),
    durum: zod_1.z.enum(['tamam', 'eksik', 'suresi_dolmus', 'bekliyor', 'reddedildi']),
    eksikKisiSayisi: zod_1.z.number().int().nonnegative().nullable(),
    kisiSayisi: zod_1.z.number().int().nonnegative().nullable(),
    /** Ek kaleminde silme hedefi (paket kaleminde null — çıkarılamaz, K-102d). */
    ekId: zod_1.z.uuid().nullable(),
});
/** YOL PLANI (K-102f) — kart ve portal AYNI uçtan okur. */
exports.evrakBeklentisiSchema = zod_1.z.object({
    evrakPaketi: zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string().min(1) }),
    kalemler: zod_1.z.array(exports.evrakBeklentiKalemiSchema),
    /** Bu firmaya özel eklenebilecek kalemler (pakette/ekte olmayan, gizli değil, firma/kişi). */
    eklenebilirKalemler: zod_1.z.array(exports.evrakPaketiKalemiSchema),
});
/** Y1 — sunucuda sayfalanmış + süzülmüş liste (ekipman Y3 deseni). */
exports.contractorListSchema = zod_1.z.object({
    satirlar: zod_1.z.array(exports.contractorDetailSchema),
    toplam: zod_1.z.number().int().nonnegative(),
    sayfa: zod_1.z.number().int().positive(),
    sayfaBoyutu: zod_1.z.number().int().positive(),
});
exports.contractorDocumentCreateSchema = zod_1.z
    .object({
    /** liste_kodu = evrak_tipi kalemi — uygulama katmanı doğrular (400). */
    evrakTipiId: zod_1.z.uuid(),
    /** Ş1: tipin ekseni `kisi` ise ZORUNLU (yüklenici çalışanı); aksi hâlde yasak (422 serviste). */
    personId: zod_1.z.uuid().nullish(),
    /** Ş1: tipin ekseni `ekipman` ise ZORUNLU (firmanın ekipmanı). */
    equipmentId: zod_1.z.uuid().nullish(),
    gecerlilikBaslangic: isoDate.nullish(),
    /** Vadeli tipte ZORUNLU, vadesiz tipte NULL (Ş6 — kural serviste). */
    gecerlilikBitis: isoDate.nullish(),
    /**
     * YENİLEME ZİNCİRİ (F3·S3.5 — Kapsam §5.13/6): bu kayıt hangi satırın
     * yeni sürümü. Red geçmişte kalır, üstüne yazılmaz; yeni sürüm YENİ
     * SATIRDIR. Aynı firma + aynı tip (+ aynı kişi) şartı serviste (422).
     * `onay_durumu` GİRDİ DEĞİLDİR.
     */
    oncekiSurumId: zod_1.z.uuid().nullish(),
})
    .refine((value) => !value.gecerlilikBaslangic ||
    !value.gecerlilikBitis ||
    value.gecerlilikBitis >= value.gecerlilikBaslangic, { message: 'gecerlilik_bitis, gecerlilik_baslangic tarihinden önce olamaz' });
exports.contractorDocumentUpdateSchema = zod_1.z
    .object({
    gecerlilikBaslangic: isoDate.nullable().optional(),
    gecerlilikBitis: isoDate.nullable().optional(),
})
    .refine((value) => Object.keys(value).length > 0, 'Güncellenecek alan yok');
/**
 * EVRAK KARARI (F3·S3.5 — Kapsam §5.13/5-6). Onayın gövdesi yoktur; RED
 * GEREKÇE İSTER ve gerekçe `hassas_veri` sınıfındaysa dosyanın BAYTI KALICI
 * silinir (madde 41.4). İşaret redde anlamlıdır: onay gövdesinde YOKTUR.
 */
exports.contractorDocumentRejectSchema = zod_1.z.object({
    gerekce: zod_1.z.string().trim().min(1, 'Red gerekçesi zorunlu'),
    /** true → baytı kalıcı silinir, kayıt (kim/ne zaman/neden) dosyasız yaşar. */
    hassasVeri: zod_1.z.boolean().optional(),
});
exports.contractorDocumentYetkileriSchema = zod_1.z.object({
    kararVerebilir: zod_1.z.boolean(),
    ekYukleyebilir: zod_1.z.boolean(),
    duzenleyebilir: zod_1.z.boolean(),
    silebilir: zod_1.z.boolean(),
});
exports.contractorDocumentDetailSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    contractorId: zod_1.z.uuid(),
    evrakTipiId: zod_1.z.uuid(),
    evrakTipiAd: zod_1.z.string(),
    eksen: zod_1.z.enum(['firma', 'kisi', 'ekipman']),
    saglik: zod_1.z.boolean(),
    zorunlu: zod_1.z.boolean(),
    personId: zod_1.z.uuid().nullable(),
    personAd: zod_1.z.string().nullable(),
    equipmentId: zod_1.z.uuid().nullable(),
    equipmentAd: zod_1.z.string().nullable(),
    gecerlilikBaslangic: isoDate.nullable(),
    gecerlilikBitis: isoDate.nullable(),
    /** Onay ekseni (F3·S3.5): `yuklendi` saha girişini AÇMAZ. */
    onayDurumu: zod_1.z.enum(['yuklendi', 'onaylandi', 'reddedildi']),
    onayAt: zod_1.z.string().nullable(),
    redGerekce: zod_1.z.string().nullable(),
    hassasVeri: zod_1.z.boolean(),
    oncekiSurumId: zod_1.z.uuid().nullable(),
    ekSayisi: zod_1.z.number().int().nonnegative(),
    /** TÜRETİLMİŞ vade durumu — eşik tip kuralı ∪ `resolveUyariEsigi`; ekran 30 yazmaz. */
    vadeDurumu: zod_1.z.enum(contractor_1.EVRAK_VADE_DURUMLARI),
    onKontrolUyarilari: zod_1.z.array(zod_1.z.string()),
    yetkiler: exports.contractorDocumentYetkileriSchema,
});
exports.contractorDocumentAttachmentSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    dosyaAdi: zod_1.z.string().min(1),
    mimeType: zod_1.z.string().min(1),
    boyutBytes: zod_1.z.number().int().nonnegative(),
    yukleyenAppUserId: zod_1.z.uuid(),
    yukleyenEtiket: zod_1.z.string().min(1),
    createdAt: zod_1.z.string(),
    indirilebilir: zod_1.z.boolean(),
});
exports.contractorPersonelSatiriSchema = zod_1.z.object({
    personId: zod_1.z.uuid(),
    adSoyad: zod_1.z.string().min(1),
    kimlikTipi: exports.kimlikTipiSchema,
    kimlikNoMaskeli: zod_1.z.string(),
    rol: zod_1.z.string(),
    workplaceId: zod_1.z.uuid(),
    workplaceAd: zod_1.z.string(),
    sahaGirisi: exports.sahaGirisiSchema,
});
exports.contractorEkipmanSatiriSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    ad: zod_1.z.string(),
    tipAd: zod_1.z.string(),
    sonrakiKontrol: isoDate.nullable(),
});
exports.pendingUserSummarySchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    email: zod_1.z.string().nullable(),
});
exports.selectablePersonnelSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    adSoyad: zod_1.z.string().min(1),
    companyIds: zod_1.z.array(zod_1.z.uuid()),
    contractorIds: zod_1.z.array(zod_1.z.uuid()),
});
// ── Rol modeli: şapka + bahçe (F1·S5 — Kapsam §20, ERD §3d) ─────────────────
exports.roleTypeSchema = zod_1.z.enum(shared_types_1.ROLE_TYPES);
/** Şapkayı yalnız holding yöneticisi verir — yetki kontrolü guard/uçta. */
exports.roleAssignmentCreateSchema = zod_1.z.object({
    appUserId: zod_1.z.uuid(),
    sapka: exports.roleTypeSchema,
});
exports.roleScopeTypeSchema = zod_1.z.enum([
    'company',
    'workplace',
    'location_branch',
    'contractor',
]);
/**
 * Bahçe kaydı: üç hedeften TAM OLARAK biri dolu ve kapsamTip ile eşleşir —
 * DB'deki CHECK `role_scope_tek_hedef`in API karşılığı (employment işveren
 * XOR deseninin üç kollusu).
 */
exports.roleScopeCreateSchema = zod_1.z
    .object({
    kapsamTip: exports.roleScopeTypeSchema,
    companyId: zod_1.z.uuid().nullish(),
    workplaceId: zod_1.z.uuid().nullish(),
    locationNodeId: zod_1.z.uuid().nullish(),
    contractorId: zod_1.z.uuid().nullish(),
})
    .superRefine((value, ctx) => {
    const hedefler = {
        company: value.companyId,
        workplace: value.workplaceId,
        location_branch: value.locationNodeId,
        contractor: value.contractorId,
    };
    const doluSayisi = [
        value.companyId,
        value.workplaceId,
        value.locationNodeId,
        value.contractorId,
    ].filter((v) => v != null).length;
    if (doluSayisi !== 1 || hedefler[value.kapsamTip] == null) {
        ctx.addIssue({
            code: 'custom',
            message: 'Bahçe kaydında kapsamTip ile eşleşen TEK hedef dolu olmalı',
        });
    }
});
exports.roleScopeDetailSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    kapsamTip: exports.roleScopeTypeSchema,
    companyId: zod_1.z.uuid().nullable(),
    workplaceId: zod_1.z.uuid().nullable(),
    locationNodeId: zod_1.z.uuid().nullable(),
    contractorId: zod_1.z.uuid().nullable(),
});
exports.roleAssignmentDetailSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    appUserId: zod_1.z.uuid(),
    sapka: exports.roleTypeSchema,
    scopes: zod_1.z.array(exports.roleScopeDetailSchema),
});
/**
 * KULLANICI DİZİNİ (F4·B2 — Y1, Kapsam §20.7): `GET /api/app-users` yanıtı.
 * Kişi kartının şapka/bahçe bölümü ve Kullanıcılar ekranı AYNI şemadan okur.
 */
exports.appUserScopeSummarySchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    kapsamTip: exports.roleScopeTypeSchema,
    hedefId: zod_1.z.uuid(),
    hedefAd: zod_1.z.string().min(1),
    /** TUR 9 / B6 — satırın yaşı (vekaletin görünürlük kolu). */
    eklendiAt: isoDate,
});
exports.appUserRoleSummarySchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    sapka: exports.roleTypeSchema,
    scopes: zod_1.z.array(exports.appUserScopeSummarySchema),
});
exports.appUserSummarySchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    personId: zod_1.z.uuid().nullable(),
    adSoyad: zod_1.z.string().nullable(),
    email: zod_1.z.string().nullable(),
    aktif: zod_1.z.boolean(),
    hicGirmedi: zod_1.z.boolean(),
    atamalar: zod_1.z.array(exports.appUserRoleSummarySchema),
    /** TUR 9 / K6 — türetilen bahçe (provenance): kaldırılamaz, soluk çizilir. */
    turetilenIsyerleri: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string().min(1) })),
});
exports.appUserSummaryListSchema = zod_1.z.array(exports.appUserSummarySchema);
/**
 * GET /api/my-authorization yanıtı (F1·S10): kullanıcının kendi yetki
 * bağlamı — kaynak bizim DB'miz (guard), token claim'i DEĞİL. `sapkalar`
 * asla boş değildir (görev kaydı olmayan kullanıcıda örtük employee).
 */
exports.myAuthorizationSchema = zod_1.z.object({
    appUserId: zod_1.z.uuid(),
    // Madde 295 — hesabın bağlı olduğu KİŞİ (yoksa null): ekran "bu kart benim
    // mi" sorusunu bundan çözer. Görünüm sadeleştirmesidir; karar uçtadır.
    personId: zod_1.z.uuid().nullable(),
    sapka: exports.roleTypeSchema,
    sapkalar: zod_1.z.array(exports.roleTypeSchema).min(1),
    // KVKK kapısı (F1.5·S11): onaylamamış temsilcide true — web kabuğu onay
    // ekranına yönlendirir; karar her istekte guard'dadır, ekran değil.
    kvkkOnayGerekli: zod_1.z.boolean(),
    /**
     * MODÜL İÇİ YAPILANDIRMA SEKMELERİNİN GÖRÜNÜRLÜĞÜ (F4·S5·B1 — IA §3/4).
     * Sunucu hesaplar; ekran ikinci bir şapka listesi tutmaz. Alanlar
     * `yuzey.ts`teki okuma listelerinden türetilir ve o listeler ilgili
     * uçların `@RequireRole`'üdür — görünmeyen sekmenin ucu da 403.
     */
    yuzeyler: zod_1.z.object({
        ptwYapilandirma: zod_1.z.boolean(),
        olayYapilandirma: zod_1.z.boolean(),
        // Madde 287 — liste sekmeleri (ana okuma ucu kapalı olan sekme çizilmez).
        gorevListesi: zod_1.z.boolean(),
        gorevlendirmeListesi: zod_1.z.boolean(),
    }),
    /**
     * P13-b (madde 225) — KABUK KARARLARI SUNUCUDAN: `portal` = temsilci dar
     * kabuğu (`PORTAL_SAPKALARI`), `saltOkunur` = guard'ın genel salt-okunur
     * kuralı (`SALT_OKUNUR_SAPKALAR`). Kabuk şapka dizgesi yazmaz.
     */
    kabuk: zod_1.z.enum(['ana', 'portal']),
    saltOkunur: zod_1.z.boolean(),
});
/**
 * Yüklenici temsilcisi hesabı açma (F1.5·S11 — Kapsam §18, karar 05.08.2026).
 * Ad/soyad Keycloak profiline gider (ilk broker-dışı hesap açma yüzeyi);
 * e-posta hem Keycloak kullanıcı adı hem app_user.email olur (küçük harfe
 * normalize — kişi↔hesap ekseni her yerde küçük harf).
 */
/**
 * POST /api/notifications/daily-run yanıtı (F2·S1 — Teknoloji §4.4/4):
 * elle tetiklenen günlük tarama sayıları. `mevcutOlay` idempotensin görünür
 * yüzüdür — aynı günün ikinci koşusunda yeni olay 0'dır, mevcutlar sayılır.
 */
exports.notificationDailyRunResultSchema = zod_1.z.object({
    yeniOlay: zod_1.z.number().int().nonnegative(),
    mevcutOlay: zod_1.z.number().int().nonnegative(),
    kuyruklananEposta: zod_1.z.number().int().nonnegative(),
});
exports.representativeAccountCreateSchema = zod_1.z.object({
    email: zod_1.z.email().max(254).toLowerCase(),
    ad: zod_1.z.string().trim().min(1).max(100),
    soyad: zod_1.z.string().trim().min(1).max(100),
    /**
     * F2·S1 (madde 38): true ise davet metni bildirim motorunun e-posta
     * kanalıyla temsilcinin adresine de gönderilir. Kopyalanabilir metin her
     * durumda döner (geri düşüş — Kapsam §18.2/2).
     */
    epostaylaGonder: zod_1.z.boolean().optional(),
});
/**
 * Davet paketi yanıtı: yetkili, davet metnini kendi kanalıyla iletir; F2·S1
 * ile istenirse e-posta kanalı da gönderir (`epostaGonderildi` sonucu taşır —
 * null: istenmedi, false: gönderilemedi → metin geri düşüşü). Geçici parola
 * yalnız bu yanıtta görünür; sistemde saklanmaz (outbox'a da yazılmaz),
 * ilk girişte değişimi Keycloak zorlar.
 */
exports.representativeAccountInviteSchema = zod_1.z.object({
    appUserId: zod_1.z.uuid(),
    kullaniciAdi: zod_1.z.string().min(1),
    geciciParola: zod_1.z.string().min(12),
    epostaGonderildi: zod_1.z.boolean().nullable(),
    girisAdresi: zod_1.z.url(),
    davetMetni: zod_1.z.string().min(1),
});
/** KVKK aydınlatma metni + kullanıcının onay durumu (madde 33 — metin yer tutucu). */
exports.kvkkAydinlatmaSchema = zod_1.z.object({
    surum: zod_1.z.string().min(1),
    metin: zod_1.z.string().min(1),
    onayGerekli: zod_1.z.boolean(),
    onayTarihi: zod_1.z.iso.datetime().nullable(),
});
/** POST /api/kvkk/consent gövdesi — onaylanan sürüm AÇIKÇA gönderilir (kör onay olmaz). */
exports.kvkkConsentCreateSchema = zod_1.z.object({
    surum: zod_1.z.string().min(1),
});
exports.kvkkConsentResultSchema = zod_1.z.object({
    surum: zod_1.z.string().min(1),
    onayTarihi: zod_1.z.iso.datetime(),
});
// ═══ Aksiyon / DÖF motoru (F2·S2 — Kapsam §22.3, ERD §6) ═══
// ✏️ TUR 2½b (V3): DÖRDÜNCÜ token `cancelled` — İPTAL ayrı SON DURUM.
// ⚠️ **KAPANIŞ DEĞİLDİR** ve bu ayrım her okuyucuda korunur: rapor iptali
// ayrı sayar, olay/uygunsuzluk kapanış türetmesi onu sayaçtan DÜŞER.
exports.actionDurumSchema = zod_1.z.enum(['open', 'completed_reported', 'closed', 'cancelled']);
/**
 * 409 RET DİLİ (T11) — kullanıcı NE YAPACAĞINI duyar, token okumaz.
 *
 * ⚠️ **D2:** durum makinesinin İÇ TOKEN'I (`completed_reported`) kullanıcıya
 * GÖSTERİLMEZ. Mesaj eskiden token'ı olduğu gibi basıyordu
 * (*"Bu geçiş yalnız 'completed_reported' durumundan yapılır"*) — kullanıcı
 * ne yapacağını değil, bizim değişken adımızı okuyordu (§2.40'ın ret dili
 * kuralı, madde 139 deseni).
 *
 * ⚠️ Durumların TÜRKÇE ADI burada DEĞİL, `incident.ts AKSIYON_DURUM_ETIKETI`
 * içindedir (rapor PDF'i ile ekran aynı kelimeyi bassın diye oraya alınmıştı).
 * Buraya ikinci bir etiket haritası yazma — bu tur bir kez yazıldı ve
 * *"Tamamlandı — onay bekliyor"* sessizce *"Tamamlandı bildirildi"*e döndü;
 * e2e yakaladı.
 */
exports.AKSIYON_DURUM_BEKLENTI_MESAJI = {
    open: 'Bu işlem yalnız açık aksiyonda yapılır — bu aksiyon artık açık değil',
    completed_reported: 'Bu işlem yalnız tamamlandı bildirimi yapılmış aksiyonda yapılır — önce sorumlunun işi bitirip bildirmesi gerekir',
    closed: 'Bu işlem yalnız kapalı aksiyonda yapılır',
    cancelled: 'Bu aksiyon iptal edildi — iptal geri alınamaz, gerekirse yeni bir aksiyon açın',
};
/**
 * DÜZELTME PAKETİ GÖVDELERİ (Tur 2½b — V2/V3/V4/V5).
 * ⚠️ İPTAL ve TERMİN DEĞİŞİKLİĞİNDE GEREKÇE ZORUNLUDUR (§22.3/12);
 * yeniden atama ve başlık düzeltmede isteğe bağlıdır — ikisi de geri
 * alınabilir düzeltmelerdir, iptal ve öteleme ise KARARDIR.
 */
exports.actionReassignSchema = zod_1.z.object({
    atananAppUserId: zod_1.z.uuid(),
    gerekce: zod_1.z.string().trim().min(1).max(2000).nullable().optional(),
});
exports.actionCancelSchema = zod_1.z.object({
    gerekce: zod_1.z.string().trim().min(1).max(2000),
});
exports.actionTerminChangeSchema = zod_1.z.object({
    terminTarihi: zod_1.z.iso.date(),
    gerekce: zod_1.z.string().trim().min(1).max(2000),
});
/** V5 — başlık/açıklama düzeltme; en az biri gönderilir (uçta 422). */
exports.actionEditSchema = zod_1.z.object({
    baslik: zod_1.z.string().trim().min(1).max(200).optional(),
    aciklama: zod_1.z.string().trim().min(1).max(2000).nullable().optional(),
});
/** İz kaydı satırı (`action_transition`) — geçiş VE düzeltme aynı listede. */
exports.actionTransitionSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    islem: zod_1.z.string().min(1),
    eskiDeger: zod_1.z.string().nullable(),
    yeniDeger: zod_1.z.string().nullable(),
    yapanEtiket: zod_1.z.string().min(1),
    gerekce: zod_1.z.string().nullable(),
    createdAt: zod_1.z.iso.datetime(),
});
/**
 * İZ İŞLEMLERİNİN KULLANICI DİLİ (D2) — iç adlar (`termin_degistir` ·
 * `approve_close`) ekranda GÖRÜNMEZ. Etiketsiz bir işlem sessiz bir
 * boşluktur; yeni işlem ekleyen bu haritayı da doldurmak zorundadır
 * (`Record` tipi derlemede zorlar — 0d dersi).
 */
exports.AKSIYON_IZ_ISLEMI = [
    'reassign',
    'cancel',
    'termin_degistir',
    'edit',
    'report_done',
    'approve_close',
    'reopen',
    // 2½-sonrası (A6): DEVİR YÜKLEMESİ. Aksiyon açılışının kendisi normalde
    // iz bırakmaz (kaydın `created_at`i o işi görür); devirde bırakır, çünkü
    // kayıtta GÖRÜNMEYEN üç şey olmuştur: atayan ikamesi · beyan kapanışı ·
    // hesabı çözülemeyen sorumlu. Gerekçe metni bunların hangisi olduğunu
    // adıyla söyler — iz KOPMAZ.
    'devir_yukleme',
];
exports.AKSIYON_IZ_ETIKETI = {
    reassign: 'Sorumlu değişti',
    cancel: 'İptal edildi',
    termin_degistir: 'Termin değişti',
    edit: 'Başlık/açıklama düzeltildi',
    report_done: 'Tamamlandı bildirildi',
    approve_close: 'Onaylandı ve kapatıldı',
    reopen: 'Geri açıldı',
    devir_yukleme: 'Sistem öncesi kayıttan devredildi',
};
/**
 * V4 — "KAÇ KEZ ÖTELENDİ" TÜRETİLİR, SAYAÇ KOLONU YOKTUR.
 * İz kaydındaki `termin_degistir` satırlarının sayısıdır; Excel çıktısı da
 * ekran da BU fonksiyondan okur (ikinci sayım, izle sayacın sessizce
 * ayrışması demekti — ERD §12/40 kapanışı).
 */
/**
 * CANLI AKSİYON DURUMLARI — *"bu iş hâlâ devam ediyor mu"* sorusunun TEK
 * cevabı (2½-sonrası düzeltmesi).
 *
 * ⚠️ **BU SABİT BİR ARIZANIN CEVABIDIR.** Üç yer bu soruyu ayrı ayrı ve
 * AYNI CÜMLEYLE soruyordu: `durum !== 'closed'` — liste süzgeci · gecikme
 * bildirimi taraması · ekrandaki *"Termin geçti"* rozeti. Tur 2½b
 * `cancelled`ı **ayrı bir son durum** olarak eklediğinde üçü de
 * güncellenmedi ve **iptal edilmiş bir DÖF gecikmiş sayılmaya devam etti:**
 * ekranda kırmızı rozet, her gün gecikme bildirimi — kapanmasının hiçbir
 * yolu olmadan (iptal terminaldir ve geri dönüşü yoktur).
 *
 * ⚠️ **İPTAL BİR KAPANIŞ DEĞİLDİR AMA BİR BİTİŞTİR.** Kapanış türetmesinde
 * sayaçtan düşer (`SAYILAN_DOF`); gecikme ekseninde ise `closed` ile aynı
 * tarafta durur. İki farklı soru, iki farklı süzgeç — ama her biri TEK yerde.
 */
exports.AKSIYON_CANLI_DURUMLAR = ['open', 'completed_reported'];
function aksiyonCanliMi(durum) {
    return exports.AKSIYON_CANLI_DURUMLAR.includes(durum);
}
/**
 * GECİKMİŞ Mİ — yanıtın `terminGecti` işareti, liste süzgeci ve bildirim
 * taraması AYNI cümleyi okur.
 *
 * ✏️ MADDE 299 (ürün sahibi 30.09.2026 — Kapsam §22.3/6 revizyonu): **TERMİN
 * GÜNÜ SON GÜNDÜR, GECİKME ERTESİ GÜN BAŞLAR** — görev vadesiyle aynı kural,
 * aynı tek yüklem (`vadeGectiMi`). *06.08.2026'da termin günü de gecikmiş
 * sayılıyordu (`<=`); sahada "termin 5 Ekim" demek "5 Ekim akşamına kadar"
 * demektir ve iki modülde iki ayrı gecikme kuralı kullanıcıyı yanıltıyordu.*
 * `bugun` saha günüdür (`yerelGun`); ⚠️ EKRAN BU FONKSİYONU ÇAĞIRMAZ —
 * işaret sunucudan gelir (`actionDetailSchema.terminGecti`).
 */
function aksiyonGecikmisMi(aksiyon, bugun) {
    return aksiyonCanliMi(aksiyon.durum) && (0, vade_1.vadeGectiMi)(aksiyon.terminTarihi, bugun);
}
function ertelemeSayisi(izler) {
    return izler.filter((iz) => iz.islem === 'termin_degistir').length;
}
/**
 * RİSK MADDESİNİN AKSİYON TAKİBİ — TEK YÜKLEM (madde 220 / R7; Kapsam
 * §16.12/16-e). Aksiyon durum yüklemlerinin YANINDA durur çünkü onları
 * okur (`risk.ts` bu dosyaya import edilir — oradan buraya import döngü
 * doğururdu).
 *
 * ⚠️ **SAYILAN DURUMLAR POZİTİF LİSTEDİR ve İPTAL İÇİNDE DEĞİLDİR.** R5
 * kapısının *"aksiyonu var"* sayımı tur 2½b'den (01.09.2026) beri **iptal
 * edilmiş** DÖF'ü de sayıyordu — o tur `cancelled` okuyucularını taradı, bu
 * sayım kaçtı. Yüksek bantta bir maddeye aksiyon açıp iptal etmek sürüm
 * dondurma kapısını açıyordu (**10 gün**, 0b ölçümü). *İptal bir bitiştir,
 * bir takip değil.* Kapalı aksiyon SAYILIR: madde üzerinde iş yapılmıştır;
 * mevcut skoru güncellemek uzmanın işidir (16/d).
 */
exports.RISK_AKSIYON_SAYILAN_DURUMLAR = ['open', 'completed_reported', 'closed'];
function riskAksiyonuSayilirMi(durum) {
    return exports.RISK_AKSIYON_SAYILAN_DURUMLAR.includes(durum);
}
/**
 * ⚠️ **SORUMLU + TERMİN MADDEDE SAKLANMAZ, AKSİYONDAN OKUNUR.** Madde birden
 * çok aksiyon taşıyabilir; satır tek bir cevap vermek zorundadır ve cevap
 * **tek kuraldan** gelir:
 *   1. iptal edilmiş aksiyon hesaba girmez;
 *   2. canlı aksiyon varsa **en yakın terminlisi** (sahadaki bir sonraki iş);
 *   3. yoksa **en son kapanan** (madde üzerinde en son yapılmış iş);
 *   4. hiç yoksa iki hücre de boştur — değer uydurulmaz.
 *
 * Satırda ayrı bir değer tutulsaydı aksiyon açıldığı an bayatlardı ve aynı
 * soruya iki cevap doğardı (seçenek ii — reddedildi).
 */
function riskMaddeTakibi(aksiyonlar) {
    const sayilan = aksiyonlar.filter((a) => riskAksiyonuSayilirMi(a.durum));
    const canli = sayilan
        .filter((a) => aksiyonCanliMi(a.durum))
        .sort((a, b) => a.terminTarihi.localeCompare(b.terminTarihi));
    const kapali = sayilan
        .filter((a) => a.durum === 'closed')
        .sort((a, b) => (b.kapanisAt ?? b.terminTarihi).localeCompare(a.kapanisAt ?? a.terminTarihi));
    const secilen = canli[0] ?? kapali[0] ?? null;
    return {
        aksiyonSayisi: sayilan.length,
        acikAksiyonSayisi: canli.length,
        sorumluAd: secilen?.atananAd ?? null,
        termin: secilen?.terminTarihi ?? null,
    };
}
/**
 * DEVİR YÜKLEME RAPORU (2½-sonrası — A1/A7; `riskItemImportReportSchema`
 * deseni). **KISMİ BAŞARI SATIR DÜZEYİNDE**, **YETKİ İSTEK DÜZEYİNDE.**
 *
 * ⚠️ **İKİ AYRI EKLENDİ SONUCU VAR ve bu bilinçlidir:** devrin bütün mesele
 * si *"kaç tanesi hâlâ iş, kaç tanesi tarih"* sorusudur. Tek bir `eklendi`
 * sayısı, 400 satırlık bir arşiv yüklemesini 400 açık işmiş gibi
 * gösterirdi.
 *
 * ⚠️ **UYARI ≠ HATA.** Satır işlendiği hâlde beyanla sistem arasında bir
 * FARK oluştuysa (atayan bulunamadı → yükleyen yazıldı · sorumlu
 * bulunamadı → ad metin olarak saklandı), satır `uyarilar` taşır. Bunları
 * hataya çevirmek, düzeltilmesi mümkün olmayan tarihsel kayıtları
 * yüklenemez yapardı; sessizce yutmak ise beyanı sistemin kendi verisiymiş
 * gibi gösterirdi.
 */
exports.AKSIYON_DEVIR_SONUCLARI = ['acik_eklendi', 'kapali_eklendi', 'hata'];
exports.aksiyonDevirSonucSchema = zod_1.z.enum(exports.AKSIYON_DEVIR_SONUCLARI);
exports.AKSIYON_DEVIR_SONUC_ETIKETI = {
    acik_eklendi: 'Açık aksiyon olarak eklendi',
    kapali_eklendi: 'Kapalı (müşteri beyanı) olarak eklendi',
    hata: 'İşlenemedi',
};
exports.actionImportRowResultSchema = zod_1.z.object({
    satir: zod_1.z.number().int().positive(),
    sonuc: exports.aksiyonDevirSonucSchema,
    mesaj: zod_1.z.string().nullable(),
    uyarilar: zod_1.z.array(zod_1.z.string()),
});
exports.actionImportReportSchema = zod_1.z.object({
    toplam: zod_1.z.number().int().min(0),
    acikEklenen: zod_1.z.number().int().min(0),
    kapaliEklenen: zod_1.z.number().int().min(0),
    hatali: zod_1.z.number().int().min(0),
    satirlar: zod_1.z.array(exports.actionImportRowResultSchema),
});
/**
 * Aksiyon açma (POST /api/actions). Termin ZORUNLU (Kapsam §22.3/6).
 * ⚠️ GEÇMİŞ TARİH SERBESTTİR ve bu bilinçlidir (§22.3/6: *"termini atayan
 * belirler"*) — geçmiş terminli aksiyon ilk günden gecikmiş doğar ve
 * bildirim üretir. (Bu satır T11'e kadar *"geçmiş olamaz — uç bugüne göre
 * denetler"* diyordu; ÖYLE BİR DENETİM HİÇ OLMADI, yorum bayattı.)
 * Durum/damgalar girdide YOKTUR: durum open doğar, damgaları sunucu basar
 * (tehlike_sinifi deseni).
 */
exports.actionCreateSchema = zod_1.z.object({
    workplaceId: zod_1.z.uuid(),
    locationNodeId: zod_1.z.uuid().nullable().optional(),
    /**
     * ✏️ T6 (tur 2): NULLABLE oldu. Tipli bir bağ (olay · risk maddesi · form
     * kaydı) varsa kaynağı SUNUCU türetir ve bu alan HİÇ GÖNDERİLMEZ —
     * zorunlu bırakmak, istemciyi sunucunun yok sayacağı bir değer uydurmaya
     * mecbur ederdi (ekranda da "seç ama hükmü yok" alanı doğururdu).
     * Doğrudan (bağsız) aksiyonda hâlâ gereklidir: çözülemezse uç 422 verir.
     */
    kaynakTipiId: zod_1.z.uuid().nullable().optional(),
    kaynakReferansNotu: zod_1.z.string().trim().min(1).max(500).nullable().optional(),
    baslik: zod_1.z.string().trim().min(1).max(200),
    aciklama: zod_1.z.string().trim().min(1).max(2000).nullable().optional(),
    atananAppUserId: zod_1.z.uuid(),
    terminTarihi: zod_1.z.iso.date(),
    /**
     * Olaydan DÖF açma (F3B·S2 — `action.incident_id`, madde 17'nin İKİNCİ tip
     * güvenli kolu). YENİ UÇ AÇILMADI: `incident_id` taşıyan aksiyon AYNI
     * kapıdan geçer — bağlam istisnası REDDEDİLDİ (U11: "nereden açtın"a göre
     * değişen yetki, envanter testinin denetleyemediği yüzey açar).
     */
    incidentId: zod_1.z.uuid().nullable().optional(),
    /**
     * Sebep düğümüne DÖF bağı (F4·B4 — "olayın DÖF'ünü açmıyoruz, SEBEPLERE
     * açıyoruz"; `action.incident_cause_id`, madde 17 ailesinin BEŞİNCİ kolu).
     * NULLABLE — genel DÖF hâlâ mümkün (O6). `incidentId`siz verilemez ve
     * düğüm AYNI olayın ağacında olmalıdır (ikisi de uçta, 422).
     */
    incidentCauseId: zod_1.z.uuid().nullable().optional(),
    /**
     * Risk maddesinden DÖF açma (F3B·S9 — `action.risk_item_id`, madde 17'nin
     * DÖRDÜNCÜ tip güvenli kolu; Kapsam §16.12/1'in üçüncü bağı: *"aksiyonlar
     * tablomuzda görülür"*). YENİ UÇ AÇILMADI ve bağlam istisnası YOK —
     * `incidentId` ile AYNI kapıdan geçer (§22.3 kurallarının tamamı koşar).
     */
    riskItemId: zod_1.z.uuid().nullable().optional(),
    /**
     * Eğitim kaydından doğan / eğitim kaydıyla kapanan DÖF bağı (F3B·S6 T6/A;
     * uca F3B·S9'da bağlandı — kolon açıldığı turda yazıcısı YOKTU ve ölü
     * kalmıştı). *"Tüm çalışanlara yüksekte çalışma risklerinin
     * hatırlatılması"* eylemi bir EĞİTİM KAYDIYSA referansla kapanır.
     * `incidentId`/`riskItemId` ile AYNI kapı — yeni uç yok.
     */
    trainingSessionId: zod_1.z.uuid().nullable().optional(),
    /**
     * UYGUNSUZLUKTAN DÖF AÇMA (Tur 2½a — Kapsam §24.1/9, U9): madde 17
     * ailesinin ALTINCI kolu. YENİ UÇ AÇILMADI — `incidentId`/`riskItemId`
     * ile AYNI kapıdan geçer ve §22.3 kurallarının tamamı koşar.
     * ⚠️ Kaynak SUNUCUDAN türetilir (T6'nın altıncı kolu — "Uygunsuzluk
     * kaydı" kütüphane kalemi); gövde `kaynakTipiId` göndermez.
     */
    nonconformityId: zod_1.z.uuid().nullable().optional(),
});
/** Tamamla-bildir gövdesi (atanan; açıklama opsiyonel — foto/dosya madde 20/S3). */
exports.actionReportDoneSchema = zod_1.z.object({
    aciklama: zod_1.z.string().trim().min(1).max(2000).nullable().optional(),
});
/** Aksiyon eylem hakları (T2) — kapı ile görünürlük tek yüklemden (§2.40). */
exports.actionYetkileriSchema = zod_1.z.object({
    tamamlayabilir: zod_1.z.boolean(),
    kapatabilir: zod_1.z.boolean(),
    geriAcabilir: zod_1.z.boolean(),
    ekYukleyebilir: zod_1.z.boolean(),
    /** P13 — kanıt yükleme kapısı (sorumlu kimliği + kapalı değil) + sebep. */
    ekKapisi: kapi_durumu_1.kapiDurumuSchema,
    /**
     * V2-V5 (Tur 2½b) — DÜZELTME HAKKI: atayan VEYA üst merci, bahçe
     * denetimli. ⚠️ TEK BAYRAK: dört düzeltmenin yetki kuralı AYNIDIR
     * (§22.3/12); dört ayrı bayrak, aynı cümlenin dört kopyası olurdu.
     * Durum kapısı bayrağa DAHİLDİR (terminal kayıtta false).
     */
    duzeltebilir: zod_1.z.boolean(),
});
exports.actionDetailSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    workplaceId: zod_1.z.uuid(),
    workplaceAd: zod_1.z.string().min(1),
    locationNodeId: zod_1.z.uuid().nullable(),
    kaynakTipiId: zod_1.z.uuid(),
    kaynakTipiAd: zod_1.z.string().min(1),
    kaynakReferansNotu: zod_1.z.string().nullable(),
    baslik: zod_1.z.string().min(1),
    aciklama: zod_1.z.string().nullable(),
    atayanAppUserId: zod_1.z.uuid(),
    atayanEtiket: zod_1.z.string().min(1),
    /**
     * ✏️ DEVİR (2½-sonrası): NULLABLE. Sistem öncesi KAPALI kaydın sorumlusu
     * kişi dosyalarında hiç bulunmayabilir; o zaman `devirSorumluMetni` dolar.
     * Açık kayıtta HER ZAMAN doludur (DB CHECK `action_sahipsiz_yalniz_kapali`).
     */
    atananAppUserId: zod_1.z.uuid().nullable(),
    /** Hesap varsa kişi adı; yoksa devirde BEYAN EDİLEN ad. Hiç boş kalmaz. */
    atananEtiket: zod_1.z.string().min(1),
    /**
     * A2 — hesabı çözülemeyen devir sorumlusunun beyan edilen adı. DOLU ise
     * `atananEtiket` bu metindir ve ekran bunu *"sistemde hesabı yok"* diye
     * işaretler: beyanı gerçek bir kullanıcıymış gibi göstermek, kaydın
     * kimin üzerinde olduğu sorusuna yanlış cevap verirdi.
     */
    devirSorumluMetni: zod_1.z.string().nullable(),
    /**
     * A5 — DEVİR KAYDI İŞARETİ. Kaynak kaleminin kütüphane ref'inden
     * TÜRETİLİR (boolean kolon açılmadı); listede rozet, Excel'de sütun.
     */
    devirKaydi: zod_1.z.boolean(),
    terminTarihi: zod_1.z.iso.date(),
    /**
     * MADDE 299 — *"termin geçti mi"* işareti SUNUCUDAN (`aksiyonGecikmisMi` +
     * saha günü). Ekran termini bugünle KARŞILAŞTIRMAZ (VG-1'in aksiyon kolu):
     * tarayıcının günü saha günü olmayabilir ve liste süzgeciyle ayrışırdı.
     */
    terminGecti: zod_1.z.boolean(),
    durum: exports.actionDurumSchema,
    /** V4 — açılıştaki termin; DEĞİŞMEZ. Ekran "ilk termin"i buradan yazar. */
    ilkTerminTarihi: zod_1.z.iso.date(),
    /** V3 — `cancelled` iken dolu. */
    iptalGerekcesi: zod_1.z.string().nullable(),
    /**
     * K3 damgası (T2·0): `approve-close` yazar, `reopen` NULL'lar.
     * ⚠️ **DEVİRDE ŞABLONDAKİ TARİHTİR (A4)** — devredilen kayıt 2020'de
     * kapanmışsa künye 2020'yi gösterir. Alan yanıtta olmasaydı beyan edilen
     * kapanış tarihi hiçbir yerde görünmez, yalnız türetmelerde yaşardı.
     */
    kapanisAt: zod_1.z.iso.datetime().nullable(),
    tamamlanmaAciklamasi: zod_1.z.string().nullable(),
    atayanUzman: zod_1.z.boolean(),
    uzmanAtamaAcik: zod_1.z.boolean(),
    createdAt: zod_1.z.iso.datetime(),
    /**
     * T2 (tur 2) — YETKİLER SUNUCUDAN. Ekran düğme görünürlüğünü BUNDAN
     * okur; `atayanUzman` damgasından kural türetmez (B3: damga BİLGİ).
     * Alan ZORUNLUDUR — opsiyonel olsaydı bayrağı yazmayı unutan bir uç
     * ekranı sessizce "hiçbir düğme yok" hâline düşürürdü (fail-closed
     * görünür, arıza görünmez).
     */
    yetkiler: exports.actionYetkileriSchema,
    // ── T3 — TİPLİ KAYIT BAĞLARI (madde 17 ailesinin beş kolu) ──────────────
    incidentId: zod_1.z.uuid().nullable(),
    incidentTakipNo: zod_1.z.string().nullable(),
    incidentCauseId: zod_1.z.uuid().nullable(),
    incidentCauseEtiket: zod_1.z.string().nullable(),
    riskItemId: zod_1.z.uuid().nullable(),
    riskItemFaaliyet: zod_1.z.string().nullable(),
    trainingSessionId: zod_1.z.uuid().nullable(),
    trainingEtiket: zod_1.z.string().nullable(),
    formSubmissionId: zod_1.z.uuid().nullable(),
    formSablonAd: zod_1.z.string().nullable(),
    /** T3 ailesinin ALTINCI kolu (Tur 2½a) — özet = takip no. */
    nonconformityId: zod_1.z.uuid().nullable(),
    nonconformityTakipNo: zod_1.z.string().nullable(),
});
exports.AKSIYON_NITELIK_ETIKETI = {
    duzeltici: 'Düzeltici',
    onleyici: 'Önleyici',
};
function aksiyonNiteligi(bag) {
    if (bag.nonconformityId && !bag.riskItemId)
        return 'duzeltici';
    if (bag.riskItemId && !bag.nonconformityId)
        return 'onleyici';
    return null;
}
exports.actionListSchema = zod_1.z.object({
    satirlar: zod_1.z.array(exports.actionDetailSchema),
    toplam: zod_1.z.number().int(),
    sayfa: zod_1.z.number().int(),
    sayfaBoyutu: zod_1.z.number().int(),
});
// ═══ UYGUNSUZLUK / BULGU (Tur 2½a — Kapsam §24 + §24.1, U1-U12) ═══════════
//
// ✏️ EVRİM: bu blok eski `actionRequest*` şemalarının yerini aldı. "Talep"
// kavramı öldü (§24.1/1); nesne aynı satır, adı değişti. Sökülen üç şema:
// `actionRequestDurumSchema` (open/converted) · `actionRequestCreateSchema`
// (iki ZORUNLU metin) · `actionRequestConvertSchema` ("dönüştürme" gövdesi —
// artık uygunsuzluktan DÖF açmak MEVCUT aksiyon ucudur, `nonconformityId`
// alanıyla).
exports.nonconformityDurumSchema = zod_1.z.enum(['reported', 'rejected', 'moved']);
/**
 * Uygunsuzluk bildirimi (§24.1/3 — U3). ALAN SIRASI SABİTTİR ve ekran onu
 * izler: işyeri → lokasyon → tarih → "Ne gördün?" → fotoğraf → "Önerin var mı?".
 *
 * ⚠️ SINIFLANDIRMA / TÜR / ŞİDDET ALANI YOKTUR: çalışana sınıflandırma yükü
 * binmez — gördüğünü yazar, sınıflandırmayı değerlendiren yapar.
 * ⚠️ `oneri` İSTEĞE BAĞLIDIR (eski `onerilenFaaliyet` zorunluydu) — öneri,
 * bildirmenin bedeli olamaz.
 */
exports.nonconformityCreateSchema = zod_1.z.object({
    workplaceId: zod_1.z.uuid(),
    locationNodeId: zod_1.z.uuid().nullable().optional(),
    tarih: zod_1.z.iso.date(),
    aciklama: zod_1.z.string().trim().min(1).max(4000),
    oneri: zod_1.z.string().trim().min(1).max(4000).nullable().optional(),
});
/** Ret (§24/4 — olay R7 deseni): gerekçe ZORUNLU, kayıt kalır. */
exports.nonconformityRejectSchema = zod_1.z.object({
    gerekce: zod_1.z.string().trim().min(1).max(2000),
});
/**
 * Uygunsuzluk → olay taşıma (§24.1/7 — U7). **Tür sorusu AKIŞI BELİRLER**
 * (`olayTuruRefId` null = uzmanın kaza kaydı → araştırma akışı); gerekçe
 * zorunlu. İşyeri/lokasyon/tarih/metin/fotoğraf KAYNAKTAN taşınır — gövdede
 * yoklar (talep→aksiyon gövdesinin "işyeri taleptendir" kuralının kardeşi).
 */
exports.nonconformityMoveSchema = zod_1.z.object({
    olayTuruRefId: zod_1.z.uuid().nullable().optional(),
    gerekce: zod_1.z.string().trim().min(1).max(2000),
});
/** Olay → uygunsuzluk taşıma: tür sorusu GEREKMEZ (uygunsuzlukta tür yoktur). */
exports.incidentMoveToNonconformitySchema = zod_1.z.object({
    gerekce: zod_1.z.string().trim().min(1).max(2000),
});
/** Uygunsuzluk eylem hakları — kapı ile görünürlük TEK yüklemden (§2.40). */
exports.nonconformityYetkileriSchema = zod_1.z.object({
    /** Değerlendiren mi (tenant listesi + bahçe) — ret/taşıma kapısı. */
    degerlendirebilir: zod_1.z.boolean(),
    /** DÖF açma: aksiyon kuralının AYNISI (uzman-kapalı rejimde uzman açamaz). */
    dofAcabilir: zod_1.z.boolean(),
    /**
     * U13 — 5x5 girilebilir mi: **değerlendiren ∧ kayıt `reported`**.
     * ⚠️ Sunucudaki `assert` AYNI yüklemi çağırır (§2.40): reddedilmiş ya da
     * taşınmış kayıtta bölüm **salt okunur** görünür, "açık görünüp reddeden"
     * bir alan bırakılmaz.
     */
    bes5Yazabilir: zod_1.z.boolean(),
    /**
     * P13 · B1/5 — değerlendirme kapısı (tenant `uygunsuzluk_degerlendirme`
     * listesi → bahçe) + sebep. ⚠️ Eski `degerlendirebilir` yorumu *"tenant
     * listesi + bahçe"* diyordu, hesap bahçeye bakmıyordu.
     */
    degerlendirmeKapisi: kapi_durumu_1.kapiDurumuSchema,
    /** P13 · B1/5 — DÖF açma = `POST actions`ın adımları + kaydın durumu + sebep. */
    dofKapisi: kapi_durumu_1.kapiDurumuSchema,
});
/**
 * Türetilmiş DÖF özeti — olayınkiyle AYNI şekil ve AYNI yüklem
 * (`olayKapaliMi`). Ekran rozeti, liste süzgeci ve public takip hepsi bunu
 * okur; ikinci bir sayım yazılmaz.
 */
exports.nonconformityDofOzetiSchema = zod_1.z.object({
    toplam: zod_1.z.number().int().nonnegative(),
    acik: zod_1.z.number().int().nonnegative(),
    kapali: zod_1.z.boolean(),
});
exports.nonconformityDetailSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    takipNo: zod_1.z.string().min(1),
    workplaceId: zod_1.z.uuid(),
    workplaceAd: zod_1.z.string().min(1),
    locationNodeId: zod_1.z.uuid().nullable(),
    locationAd: zod_1.z.string().nullable(),
    tarih: zod_1.z.iso.date(),
    aciklama: zod_1.z.string().min(1),
    oneri: zod_1.z.string().nullable(),
    durum: exports.nonconformityDurumSchema,
    redGerekce: zod_1.z.string().nullable(),
    /** R5 türetmesi — bildiren NULL ise anonim (kolon AÇILMAZ, U3'ün ikizi). */
    anonim: zod_1.z.boolean(),
    /** Anonimde null; künyede gizlenir. */
    bildirenEtiket: zod_1.z.string().nullable(),
    /** Taşıma çapraz bağı — hedef olayın takip numarası (iki yönde okunur). */
    tasinanIncidentId: zod_1.z.uuid().nullable(),
    tasinanIncidentTakipNo: zod_1.z.string().nullable(),
    /** Olaydan taşınmışsa kaynağın takip numarası (çapraz bağın diğer yarısı). */
    kaynakIncidentId: zod_1.z.uuid().nullable(),
    kaynakIncidentTakipNo: zod_1.z.string().nullable(),
    /** Göçen kayıtlarda dolu kalır; YENİ kayıt bunu doldurmaz (U10). */
    formSubmissionId: zod_1.z.uuid().nullable(),
    /**
     * U13 — 5x5 DEĞERLENDİRME (tur 11 / R3-c). Üçü birlikte NULL ya da
     * birlikte dolu (DB CHECK `nonconformity_bes5_butunlugu`); puan
     * **TÜRETİLİR** ve gövdeden alınmaz.
     * ⚠️ **KAPI DEĞİL** — hiçbir durum geçişi, kapanış türetmesi ya da DÖF
     * kuralı bu değerleri okumaz; önceliklendirme ve raporlama girdisidir.
     */
    olasilik5: zod_1.z.number().int().nullable(),
    siddet5: zod_1.z.number().int().nullable(),
    puan5x5: zod_1.z.number().int().nullable(),
    dof: exports.nonconformityDofOzetiSchema,
    yetkiler: exports.nonconformityYetkileriSchema,
    /**
     * SAHA TURU / S4 (Kapsam §27): kayıt bir turun seçilmiş gözleminden
     * doğduysa kaynak tur — TERS İLİŞKİDEN türetilir (`site_tour_observation.
     * nonconformity_id`), uygunsuzlukta kaynak kolonu YOKTUR (U8).
     */
    kaynakSahaTuru: zod_1.z.object({ id: zod_1.z.uuid(), takipNo: zod_1.z.string().min(1) }).nullable(),
    createdAt: zod_1.z.iso.datetime(),
});
/**
 * BİLDİRİM SONUCU (U8 — Kapsam §24.1/8): tür KAPIYI SEÇER, bildiren
 * *"olay mı uygunsuzluk mu"* sorusuyla HİÇ karşılaşmaz. `POST /api/incidents`
 * ve public QR ucu bu zarfı döner; ekran `kap` alanını okuyup doğru kayda
 * yönlendirir.
 *
 * ⚠️ İKİ AYRI UÇ AÇILMADI ve bu bilinçlidir: kapıyı istemciye seçtirmek,
 * yönlendirmenin İKİNCİ bir yerde (ekranda) yazılması demek olurdu ve iki
 * kanal (QR · iç ekran) zamanla ayrışırdı (§2.40'ın tek-yüklem kolu).
 */
const incident_1 = require("./incident");
exports.bildirimSonucuSchema = zod_1.z.object({
    kap: zod_1.z.enum(['olay', 'uygunsuzluk']),
    olay: incident_1.incidentSummarySchema.nullable(),
    uygunsuzluk: exports.nonconformityDetailSchema.nullable(),
});
/** P4 — sayfalama + görünür süzgeç + toplam (aksiyon listesiyle aynı kalıp). */
exports.nonconformityListSchema = zod_1.z.object({
    satirlar: zod_1.z.array(exports.nonconformityDetailSchema),
    toplam: zod_1.z.number().int(),
    sayfa: zod_1.z.number().int(),
    sayfaBoyutu: zod_1.z.number().int(),
});
/** Geçiş geçmişi satırı (`nonconformity_transition`). */
exports.nonconformityTransitionSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    islem: zod_1.z.string().min(1),
    eskiDurum: zod_1.z.string().min(1),
    yeniDurum: zod_1.z.string().min(1),
    yapanEtiket: zod_1.z.string().nullable(),
    gerekce: zod_1.z.string().nullable(),
    createdAt: zod_1.z.iso.datetime(),
});
/** Atanabilir hedef (Kapsam §22.3/7) — kişi bağlı aktif hesap. */
exports.assignableUserSchema = zod_1.z.object({
    appUserId: zod_1.z.uuid(),
    etiket: zod_1.z.string().min(1),
});
/** GET /api/tenant-settings yanıtı (F2·S2 — satır yoksa varsayılan döner).
 *  F3B·S2 genişlemesi: U4 anahtarı + U6 liste anahtarları (boş = varsayılan). */
exports.tenantSettingsSchema = zod_1.z.object({
    // Kapı anahtarları (5) — panelde görünen sınıf (Y7).
    // ✏️ Tur 4½: `gorevlendirmeYetkinlikZorunlu` eklendi (§25/5).
    uzmanAksiyonAtama: zod_1.z.boolean(),
    anonimBildirimAcik: zod_1.z.boolean(),
    egitimDegerlendirmeAcik: zod_1.z.boolean(),
    riskAksiyonZorunlu: zod_1.z.boolean(),
    /** G5 — VARSAYILAN KAPALI: açan holdingde eksik yetkinlikle görevlendirme
     *  422; kapalıyken kayıt açılır ve *"eksik"* damgası taşır (§25/5). */
    gorevlendirmeYetkinlikZorunlu: zod_1.z.boolean(),
    // Liste anahtarları (5) — boş liste = VARSAYILAN geçerli (c1).
    // ✏️ T2·0: `olayKapanis` KALKTI (kapanış türetilir — K9).
    olayInceleme: zod_1.z.array(exports.roleTypeSchema),
    calismaSaatiGiris: zod_1.z.array(exports.roleTypeSchema),
    egitimKaydi: zod_1.z.array(exports.roleTypeSchema),
    /** F3B·S8 — S2: sağlık kanaati YAZMA listesi (varsayılan hekim + YSP +
     *  uzman). OKUMA listesi tenant yapılandırması DEĞİLDİR (§16.11/10 — o,
     *  veri izolasyonunun sınırıdır ve kodda sabittir). */
    saglikKanaatGiris: zod_1.z.array(exports.roleTypeSchema),
    riskDegerlendirme: zod_1.z.array(exports.roleTypeSchema),
    /** U5 (Tur 2½a) — uygunsuzluğu KİM değerlendirir (ret · olaya taşıma).
     *  DÖF açma bu listeden okunmaz: o, aksiyon kuralının kendisidir (U6). */
    uygunsuzlukDegerlendirme: zod_1.z.array(exports.roleTypeSchema),
    // Değer ve eşik anahtarları (4) — F4·S2'de ikisi YENİ (Y1).
    qrOzetKapsami: zod_1.z.enum(['sirket', 'lokasyon']),
    riskMetodolojisi: risk_1.riskMetodolojisiSchema,
    majorArastirmaEsigi: zod_1.z.number().int().min(0).max(5),
    /** R4-R5 (tur 11) — risk yenileme periyodu; `null` = MEVZUAT TAVANI. */
    riskYenilemePeriyotAy: egitim_1.tehlikeSinifiHaritasiSchema.nullable(),
    /** T10 — termin ön-uyarısı (gün). `null` = ön-uyarı gönderilmez. */
    aksiyonTerminOnUyariGun: zod_1.z.number().int().min(1).max(90).nullable(),
    /** ✏️ **TUR 12 / K1 — DASHBOARD ORAN ÇARPANININ VARSAYILANI.**
     *  ⚠️ Bir KİLİT DEĞİL, ekranın AÇILIŞ DEĞERİ: çarpan dashboard'da
     *  SÜZGEÇTİR (Kapsam §26.1). Ayara kilitlenseydi §16.8.1/2'nin gerekçesi
     *  (aynı dönem için iki farklı çarpanla EŞZAMANLI çıktı) çiğnenirdi. */
    kpiCarpan: kpi_1.kpiCarpanSchema,
    /** KKD (§30/Z3) — zimmet formunun matbu metni; varsayılan standart metin. */
    kkdZimmetMetni: zod_1.z.string().min(1),
    /** DÖF öneri eşiği — ✏️ **AYAR DEĞİL, TÜRETİLMİŞ DEĞER** (tur 11 / R2):
     *  yüksek bandın alt sınırı; ekran onu salt okunur gösterir ve düzenleme
     *  yeri **bant tablosudur**. Bant tanımsızsa `null` ve öneri hiç çıkmaz. */
    riskDofOneriEsigiGecerli: zod_1.z.number().nonnegative().nullable(),
    /**
     * "AKTİF OLMAYAN KONTROLLER" PANELİ (Y4 + Y7) — **DÜZ LİSTE, yorum yok.**
     * Yalnız KAPALI **kapı** anahtarları; liste ve değer/eşik anahtarları
     * buraya GİRMEZ (onların "kapalı" hâli yoktur). Panel sunucuda kurulur ki
     * ekran ikinci bir "hangi anahtar panele girer" kuralı yazmasın.
     */
    kapaliKontroller: zod_1.z.array(zod_1.z.object({ anahtar: zod_1.z.string().min(1), etiket: zod_1.z.string().min(1) })),
    /** ✏️ Dilim 2 (bulgu 75) — iş izni kontrol muslukları panosu (Kapsam §23/6-7 ✏️). */
    ptwKontrolOzeti: ptw_kontrol_matrisi_1.ptwKontrolOzetiSchema,
});
/** PUT /api/tenant-settings/:anahtar gövdesi — sınıfına göre boolean ·
 *  şapka dizisi · kapalı enum · sayı. ASIL guard `tenantSettingDegerIhlali`
 *  (anahtar bazlı, 422); buradaki union yalnız kaba biçimi süzer. */
/**
 * ⚠️ **GÖVDE ŞEKLİ GENİŞ, KURAL ANAHTARDA.** Aynı uç boolean · sayı · enum ·
 * şapka dizisi ve (tur 11'den beri) **harita** taşır; hangi anahtarın hangi
 * şekli aldığına `tenantSettingDegerIhlali` karar verir ve **422** üretir.
 * Şemayı anahtar başına ayırmak, kuralı iki yere bölerdi.
 */
exports.tenantSettingUpdateSchema = zod_1.z.object({
    deger: zod_1.z.union([
        zod_1.z.boolean(),
        zod_1.z.number(),
        zod_1.z.null(),
        zod_1.z.string(),
        zod_1.z.array(exports.roleTypeSchema),
        // R4-R5 (tur 11): `risk_yenileme_periyot_ay` — {az, tehlikeli, cok}.
        zod_1.z.record(zod_1.z.string(), zod_1.z.number()),
    ]),
});
/** Zil (F2·S2 — Kapsam §22.2/8): kullanıcının kendi in_app teslimatları. */
exports.notificationBellItemSchema = zod_1.z.object({
    deliveryId: zod_1.z.uuid(),
    tip: zod_1.z.string().min(1),
    /**
     * K-103a/b — satırın gittiği yol, SUNUCUDA `bildirimHedefYolu`ndan çözülür
     * (türetilen sınıfın üst kaydı ve sahip kolu yalnız sunucuda bilinir).
     * Ekran bağ kurmaz; bu değeri çizer.
     */
    hedef: zod_1.z.string().startsWith('/'),
    icerik: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
    olayGunu: zod_1.z.iso.date(),
    okunduAt: zod_1.z.iso.datetime().nullable(),
    createdAt: zod_1.z.iso.datetime(),
});
exports.notificationBellSchema = zod_1.z.object({
    okunmamis: zod_1.z.number().int().nonnegative(),
    kalemler: zod_1.z.array(exports.notificationBellItemSchema),
});
/** POST /api/notifications/read gövdesi — id listesi verilmezse tümü okunur. */
exports.notificationReadSchema = zod_1.z.object({
    deliveryIds: zod_1.z.array(zod_1.z.uuid()).max(200).optional(),
});
exports.notificationReadResultSchema = zod_1.z.object({
    okunduSayisi: zod_1.z.number().int().nonnegative(),
});
// ═══ Dosya/ek çekirdeği (F2·S3 — Kapsam §22.4, Teknoloji §4.11, madde 20) ═══
/** Dosya başına üst sınır: 10 MB (Kapsam §22.4/1). */
exports.DOSYA_MAX_BOYUT_BYTES = 10 * 1024 * 1024;
/** Aksiyon başına ek sınırı (Kapsam §22.4/1); form motorunda ALAN başına. */
exports.AKSIYON_EK_LIMIT = 5;
/**
 * FORM KAYDI BAŞINA EK SINIRI (tur 3 artçısı — G1).
 *
 * ⚠️ **ALAN BAŞINA SINIR TEK BAŞINA YETMİYORDU.** Madde bazında fotoğraf
 * açıldığı an bir kaydın taşıyabileceği dosya sayısı **madde sayısıyla
 * çarpılır**: kırk maddelik bir saha denetimi, madde başına beş fotoğrafla
 * iki yüz dosyaya çıkardı — PDF'i basılamaz, listesi okunamaz, indirmesi
 * bitmez bir kayıt.
 *
 * Sayı `AKSIYON_EK_LIMIT`in katıdır (5 × 4), **yeni bir büyüklük
 * uydurulmadı**: yirmi ek, uygunsuz çıkan bir avuç maddenin her birine
 * birkaç kare düşen gerçek bir saha denetimini rahatça karşılar; aşan
 * kullanıcı ya fotoğrafları seçmeli ya ikinci bir kontrol kaydı açmalıdır —
 * ikisi de bir kaydın *"bir kontrol olayı"* olduğu gerçeğine uyar.
 */
exports.FORM_KAYIT_EK_LIMIT = exports.AKSIYON_EK_LIMIT * 4;
/** İzinli içerik tipleri (Kapsam §22.4/2) ve indirmede dönen mime değerleri. */
exports.DOSYA_TIP_MIME = {
    jpg: 'image/jpeg',
    png: 'image/png',
    heic: 'image/heic',
    pdf: 'application/pdf',
};
/** Uzantı → tip eşlemesi (eş anlamlılar dahil); listede olmayan uzantı reddedilir. */
const DOSYA_UZANTI_TIP = {
    jpg: 'jpg',
    jpeg: 'jpg',
    png: 'png',
    heic: 'heic',
    heif: 'heic',
    pdf: 'pdf',
};
/** HEIC ailesinin ISO-BMFF `ftyp` marka kutucukları (heif dahil). */
const HEIC_MARKALARI = new Set(['heic', 'heix', 'hevc', 'hevx', 'heim', 'heis', 'mif1', 'msf1']);
/**
 * İçerik imzasından (magic bytes) tip çıkarır — UZANTIYA GÜVENİLMEZ
 * (Kapsam §22.4/2). Tanınmayan içerik null döner (izin listesi kapalıdır:
 * yeni tip eklemek ürün kararıdır).
 */
function sniffDosyaTipi(bytes) {
    if (bytes.length >= 3 && bytes[0] === 0xff && bytes[1] === 0xd8 && bytes[2] === 0xff) {
        return 'jpg';
    }
    const PNG_IMZA = [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a];
    if (bytes.length >= 8 && PNG_IMZA.every((deger, i) => bytes[i] === deger)) {
        return 'png';
    }
    // %PDF-
    if (bytes.length >= 5 &&
        bytes[0] === 0x25 &&
        bytes[1] === 0x50 &&
        bytes[2] === 0x44 &&
        bytes[3] === 0x46 &&
        bytes[4] === 0x2d) {
        return 'pdf';
    }
    // ISO-BMFF: 4-7 "ftyp", 8-11 marka (heic ailesi).
    if (bytes.length >= 12) {
        const ftyp = String.fromCharCode(bytes[4], bytes[5], bytes[6], bytes[7]);
        const marka = String.fromCharCode(bytes[8], bytes[9], bytes[10], bytes[11]).toLowerCase();
        if (ftyp === 'ftyp' && HEIC_MARKALARI.has(marka))
            return 'heic';
    }
    return null;
}
/**
 * Dosya kabul kapısı (Kapsam §22.4/2): içerik imzası çıkarılır VE uzantıyla
 * eşleşmesi istenir — pdf gövdeli `.jpg` reddedilir (içerik izinli bir tip
 * olsa bile: ad ile içerik çelişen dosya güvenilmezdir). mime her zaman
 * İÇERİKTEN döner, istemcinin beyanı okunmaz.
 */
function dogrulaDosyaImza(dosyaAdi, bytes) {
    const tip = sniffDosyaTipi(bytes);
    if (!tip)
        return { gecerli: false, sebep: 'tip_taninmadi' };
    const uzanti = dosyaAdi.includes('.') ? dosyaAdi.split('.').pop().toLowerCase() : '';
    const uzantiTip = DOSYA_UZANTI_TIP[uzanti];
    if (!uzantiTip)
        return { gecerli: false, sebep: 'uzanti_taninmadi' };
    if (uzantiTip !== tip)
        return { gecerli: false, sebep: 'uzanti_icerik_uyusmuyor' };
    return { gecerli: true, tip, mimeType: exports.DOSYA_TIP_MIME[tip] };
}
/** Aksiyon eki satırı (GET /api/actions/:id/attachments — Kapsam §22.4/5). */
exports.actionAttachmentSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    dosyaAdi: zod_1.z.string().min(1),
    mimeType: zod_1.z.string().min(1),
    boyutBytes: zod_1.z.number().int().positive(),
    yukleyenAppUserId: zod_1.z.uuid(),
    yukleyenEtiket: zod_1.z.string().min(1),
    createdAt: zod_1.z.iso.datetime(),
    /**
     * P13-c (madde 227) — silme kapısı SATIR BAŞINA: şapka → kapalı kayıt →
     * sahiplik (yükleyen VEYA holding yön.). Aksiyon ve uygunsuzluk eki aynı
     * şemayı taşır; ekran düğmeyi bundan çizer, sebebi bölüm başına bir kez yazar.
     */
    silmeKapisi: kapi_durumu_1.kapiDurumuSchema,
});
// ═══ Form / şablon motoru (F2·S4 — Kapsam §22.5, ERD §6c) ═══
exports.formTemplateDurumSchema = zod_1.z.enum(['active', 'archived']);
// ❌ `formTemplateDuzeySchema` F4·S6'da DÜŞTÜ (T1 — Kapsam §22.5c): şablonun
// düzeyi değil KAPSAMI vardır ve kapsam bir İŞYERİ KÜMESİDİR. Geri getirme —
// kapsamın ikinci bir kaynağı olurdu (M2).
exports.formVersionYayinDurumuSchema = zod_1.z.enum(['draft', 'published']);
exports.formSubmissionDurumSchema = zod_1.z.enum(['draft', 'submitted']);
exports.formTemplateSummarySchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    kod: zod_1.z.string().min(1),
    ad: zod_1.z.string().min(1),
    durum: exports.formTemplateDurumSchema,
    kutuphaneden: zod_1.z.boolean(),
    bildirimUretir: zod_1.z.boolean(),
    /** F4·S6 (T2) — KAPSAM: şablonun geçerli olduğu işyeri kümesi. Ekran bu üç
     *  alandan kendi etiketini kurar; ikinci bir kural türetmez (§2.16/B3).
     *  `kapsamTumIsyerleri` = tenant'ın TÜM canlı işyerlerini kapsıyor (eski
     *  "merkezî"nin karşılığı); `kapsamAdlari` gösterim için İLK BİRKAÇ addır
     *  (tam liste kapsam düzenleme yüzeyinden okunur). */
    kapsamIsyeriSayisi: zod_1.z.number().int().nonnegative(),
    kapsamTumIsyerleri: zod_1.z.boolean(),
    kapsamAdlari: zod_1.z.array(zod_1.z.string().min(1)),
    /** Çoğaltma kökeni (ERD §12/33 = c) — kopya detayındaki köken satırı. */
    kaynakTemplateId: zod_1.z.uuid().nullable(),
    kaynakTemplateAd: zod_1.z.string().min(1).nullable(),
    /** 42.8 — kayıttan aksiyonun kaynağı; kütüphane nüshasında ürün verisi. */
    aksiyonKaynagiId: zod_1.z.uuid().nullable(),
    /** Düğme görünürlüğü SUNUCUDAN gelir (S4 deseni — §2.6f): ekran ikinci
     *  yetki kuralı yazmaz, görünmeyen düğmenin ucu da reddeder. */
    yetkiler: zod_1.z.object({
        duzenleyebilir: zod_1.z.boolean(),
        cogaltabilir: zod_1.z.boolean(),
        silebilir: zod_1.z.boolean(),
    }),
    yayinliSurumNo: zod_1.z.number().int().positive().nullable(),
    yayinliSurumId: zod_1.z.uuid().nullable(),
    taslakSurumNo: zod_1.z.number().int().positive().nullable(),
    taslakSurumId: zod_1.z.uuid().nullable(),
    kayitSayisi: zod_1.z.number().int().nonnegative(),
    /** S8-4 (F4·S8): izin türü şablonu FORMLAR modülünden DOLDURULMAZ — ekran
     *  "Doldur"u bu bayrakla gizler; asıl kapı uçtadır (410). */
    izinTuruFormu: zod_1.z.boolean(),
});
/**
 * ŞABLON LİSTESİ SÜZGECİ (F4·S6 · Y1). ⚠️ Tanınmayan `durum` değeri **400**
 * verir, sessizce *"tümü"*ye DÜŞMEZ — kullanıcı daralttığını sanarken listenin
 * genişlemesi §2.40'ın tur 10 / K5 vakasıdır.
 */
exports.formTemplateSuzgecSchema = zod_1.z.object({
    ara: zod_1.z.string().trim().min(1).max(200).optional(),
    durum: zod_1.z.enum(['hepsi', 'active', 'archived']).default('hepsi'),
    /** Kapsam ekseni: *"bu işyerinde hangi formlar geçerli"* (T5'in yüzeyi). */
    workplaceId: zod_1.z.uuid().optional(),
    sayfa: zod_1.z.number().int().positive().default(1),
    sayfaBoyutu: zod_1.z.number().int().positive().max(100).default(25),
});
/**
 * SÜRÜM GEÇMİŞİ (F4·S6 · Y4). ⚠️ **ŞEMA TAŞIMAZ** — liste hafif kalır ve
 * içeriği okumak isteyen tekil sürüm ucuna gider. `kayitSayisi` o sürümle
 * doldurulmuş kayıt sayısıdır: §22.5/3'ün (*kayıt KENDİ sürümüyle okunur*)
 * ekranda görünen kanıtı.
 */
exports.formTemplateSurumGecmisiSchema = zod_1.z.array(zod_1.z.object({
    id: zod_1.z.uuid(),
    surumNo: zod_1.z.number().int().positive(),
    yayinDurumu: exports.formVersionYayinDurumuSchema,
    yayinlanmaAt: zod_1.z.string().nullable(),
    createdAt: zod_1.z.string(),
    kayitSayisi: zod_1.z.number().int().nonnegative(),
}));
/**
 * ✏️ **F4·S6 (Y1) — SAYFALANMIŞ ŞABLON LİSTESİ** (`personListSchema` deseni).
 *
 * ⚠️ **P4 AÇIĞIYDI:** aynı ekranın DOLU KAYIT listesi F3'ten beri sayfalıydı;
 * şablon listesi tümünü indiriyordu. Kapsam modeliyle birlikte şablon sayısı
 * artar (her müşteri kendi işyerine form açabilir — T6) ve liste hızla
 * okunamaz hâle gelirdi. `toplam` HER ZAMAN döner.
 */
exports.formTemplateListSchema = zod_1.z.object({
    satirlar: zod_1.z.array(exports.formTemplateSummarySchema),
    toplam: zod_1.z.number().int().nonnegative(),
    sayfa: zod_1.z.number().int().positive(),
});
exports.formTemplateVersionDetailSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    formTemplateId: zod_1.z.uuid(),
    formTemplateAd: zod_1.z.string().min(1),
    surumNo: zod_1.z.number().int().positive(),
    yayinDurumu: exports.formVersionYayinDurumuSchema,
    yayinlanmaAt: zod_1.z.iso.datetime().nullable(),
    sema: zod_1.z.unknown(),
    createdAt: zod_1.z.iso.datetime(),
});
/**
 * Şablon güncelleme gövdesi. `durum` = arşivleme/geri açma; `ad` = YALNIZ
 * kütüphane dışı (NULL-ref) şablonda ad değişikliği (Ş5 — kimlik kilidi
 * yalnız kütüphane nüshasında işler; kütüphane nüshasında `ad` gönderilirse
 * 422). `kod` girdide bilinçli YOK: teknik kimliktir, sunucu üretir.
 */
exports.formTemplateUpdateSchema = zod_1.z
    .object({
    durum: exports.formTemplateDurumSchema.optional(),
    ad: zod_1.z.string().trim().min(1).max(200).optional(),
    /** 42.8 — YALNIZ NULL-ref şablonda: kayıttan aksiyonun kaynağı (sözlük
     *  kalemi id'si; null = kaynağı kaldır → kayıttan aksiyon 422). */
    aksiyonKaynagiId: zod_1.z.uuid().nullable().optional(),
})
    .refine((v) => v.durum !== undefined || v.ad !== undefined || v.aksiyonKaynagiId !== undefined, {
    message: 'En az bir alan gönderilmeli (durum, ad veya aksiyonKaynagiId)',
});
/**
 * BAHÇELİ şablon açma gövdesi — çoğaltma ve boş tuval AYNI şekli kullanır
 * (Ş2). `ad` ZORUNLUDUR (Ş5 — otomatik "(kopya)" üretilmez, ad kullanıcıdan
 * gelir). Kapsam: `companyId` XOR `locationNodeId` (bahçe bağı — Ç2: kapsam
 * bahçesi neyse odur); İKİSİ BİRDEN gönderilemez. İkisi de boşsa sunucu
 * açanın bahçesinden TEK adaysa türetir, değilse 422.
 */
/**
 * ŞABLON AÇMA (boş tuval + çoğaltma) — F4·S6 (T2/T4/T6).
 *
 * ⚠️ `companyId`/`locationNodeId` DÜŞTÜ; yerine **KAPSAM** gelir: şablonun
 * geçerli olacağı **işyeri kümesi**. ⚠️ **T6 — işyeri bahçeli uzman kendi
 * işyerini yazabilir**; eski *"işyeri bahçesinden şablon bağı türetilemez"*
 * 422'si böylece konusuz kaldı.
 *
 * ⚠️ **Kapsam BOŞ OLAMAZ** (`min(1)`): kapsamsız şablon **hiçbir işyerinde
 * geçerli değildir** ve listede kimseye görünmez — sessizce ölü doğardı
 * (§2.40'ın *"görünür, çalışmaz"* sınıfının ters yönü).
 * ⚠️ Her işyerinin **yazanın bahçesinde** olduğu sunucuda doğrulanır (T4).
 */
exports.formTemplateKapsamGirdisi = zod_1.z
    .array(zod_1.z.uuid())
    .min(1, 'Kapsam en az bir işyeri taşır')
    .max(500)
    .refine((v) => new Set(v).size === v.length, { message: 'Kapsamda tekrar eden işyeri var' });
exports.formTemplateBahceliOlusturSchema = zod_1.z.object({
    ad: zod_1.z.string().trim().min(1).max(200),
    kapsamIsyeriIdleri: exports.formTemplateKapsamGirdisi,
    /** 42.8 — kurucunun sözlükten seçtiği aksiyon kaynağı (opsiyonel;
     *  çoğaltmada verilmezse KAYNAK şablonunkini devralır). */
    aksiyonKaynagiId: zod_1.z.uuid().nullable().optional(),
});
/**
 * EXCEL'DEN ŞABLON (P1 — Namet grubu, 01.11.2026): multipart gövdesi. Dosya
 * `dosya` alanında; metin alanları multipart'ta DİZGE gelir — kapsam JSON
 * dizisi olarak taşınır ve burada **aynı kapsam kuralından** geçer (boş
 * kapsam yok — T5; bahçe denetimi uçta). İş emrinin *"kapsam boş kalır"*
 * satırı §22.5c ile çelişir (kapsamsız şablon ölü doğar ve dar bahçeli
 * açana bile görünmez); kapsam bu yüzden yüklemede sorulur — mevcut Yeni
 * şablon sayfasında, ikinci bir ekran açılmadan.
 */
exports.formTemplateExcelIceAktarGovdesiSchema = zod_1.z.object({
    ad: zod_1.z.string().trim().min(1).max(200),
    kapsamIsyeriIdleri: zod_1.z.preprocess((v) => {
        if (typeof v !== 'string')
            return v;
        try {
            return JSON.parse(v);
        }
        catch {
            return v;
        }
    }, exports.formTemplateKapsamGirdisi),
    aksiyonKaynagiId: zod_1.z.preprocess((v) => (v === '' || v === 'null' ? null : v), zod_1.z.uuid().nullable().optional()),
});
exports.formTemplateExcelIceAktarUyarisiSchema = zod_1.z.object({
    satir: zod_1.z.number().int().positive(),
    alan: zod_1.z.enum(['Tip', 'Cevap seti', 'Fotoğraf', 'Not', 'Zorunlu']),
    deger: zod_1.z.string(),
});
/** KAPSAM YAZMA gövdesi (`PUT form-templates/:id/scope` — T4). */
exports.formTemplateKapsamSchema = zod_1.z.object({
    kapsamIsyeriIdleri: exports.formTemplateKapsamGirdisi,
});
/**
 * Taslak sürümün şemasını güncelleme — gövde şemanın kendisidir.
 *
 * ⚠️ **TASLAK ŞEMASI** kullanılır (`formSemaTaslakSchema`): boş tuvalin ilk
 * taslağı boş doğar ve son müşteri alanı silinince yine boşalabilir. Yayın
 * kapısı bu uçta DEĞİL `publish` ucundadır (`formSemaSchema`, min 1) —
 * taslak boş olabilir, yayın olamaz.
 */
exports.formVersionUpdateSchema = zod_1.z.object({
    sema: form_schema_1.formSemaTaslakSchema,
});
/** Excel'den şablon yanıtı: açılan şablonun özeti + tanınmayan değer uyarıları (satır · alan · değer). */
exports.formTemplateExcelIceAktarSonucSchema = zod_1.z.object({
    sablon: exports.formTemplateSummarySchema,
    taslakSurumId: zod_1.z.uuid(),
    bolumSayisi: zod_1.z.number().int().nonnegative(),
    maddeSayisi: zod_1.z.number().int().positive(),
    uyarilar: zod_1.z.array(exports.formTemplateExcelIceAktarUyarisiSchema),
});
exports.formSubmissionAttachmentSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    alanKodu: zod_1.z.string().min(1),
    dosyaAdi: zod_1.z.string().min(1),
    mimeType: zod_1.z.string().min(1),
    boyutBytes: zod_1.z.number().int().positive(),
    yukleyenAppUserId: zod_1.z.uuid(),
    createdAt: zod_1.z.iso.datetime(),
    /** P13-c (madde 227) — silme kapısı: doldurma şapkası → gönderilmiş kayıt (durum) → sahiplik. */
    silmeKapisi: kapi_durumu_1.kapiDurumuSchema,
});
exports.formSubmissionSummarySchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    formTemplateId: zod_1.z.uuid(),
    formTemplateAd: zod_1.z.string().min(1),
    templateVersionId: zod_1.z.uuid(),
    surumNo: zod_1.z.number().int().positive(),
    workplaceId: zod_1.z.uuid(),
    workplaceAd: zod_1.z.string().min(1),
    locationNodeId: zod_1.z.uuid().nullable(),
    dolduranAppUserId: zod_1.z.uuid().nullable(),
    dolduranEtiket: zod_1.z.string().min(1),
    doldurmaTarihi: zod_1.z.iso.date(),
    durum: exports.formSubmissionDurumSchema,
    /** S8-4 (F4·S8): izne bağlı kayıt arşivde izin bağlantısıyla görünür. */
    ptwPermitId: zod_1.z.uuid().nullable(),
    /** Tur 3 (F1) — kayıt bir EKİPMANIN kontrolüyse o ekipman (§22.6a/Z2). */
    ekipmanId: zod_1.z.uuid().nullable(),
    ekipmanAd: zod_1.z.string().min(1).nullable(),
    /**
     * SAHA TURU / S2 (Kapsam §27): dolu ise kayıt bir DENETİM OTURUMUNUN
     * formudur — uygunsuz maddeleri tur kapanışında BULGU ADAYIDIR
     * (`formKaydiBulguKaynagiMi`). Boşsa gönderim hiçbir şey doğurmaz (U10).
     */
    siteTourId: zod_1.z.uuid().nullable(),
    createdAt: zod_1.z.iso.datetime(),
});
/**
 * DOLDURMA HEDEFLERİ (Tur 3 / F1) — *"bu formu NEREDE doldurabilirim?"*
 *
 * ⚠️ **HAVUZ SUNUCUDAN GELİR** çünkü iki kaynağı vardır ve ekran ikisini de
 * bilemez: **bahçe** (şapkalı kullanıcı) ve **atama** (şapkasız çalışan —
 * 42.1). Ekran şirket/işyeri listesini kendi çıkarırsa şapkasız çalışan BOŞ
 * liste görür ve *"doldurabiliyorum ama hiçbir yerde görünmüyor"* durumu
 * doğar (§2.40'ın kardeşi: yol açılmamış kapı).
 */
exports.formDoldurmaHedefleriSchema = zod_1.z.object({
    isyerleri: zod_1.z.array(zod_1.z.object({
        workplaceId: zod_1.z.uuid(),
        workplaceAd: zod_1.z.string().min(1),
        companyAd: zod_1.z.string().min(1),
        /** Havuza hangi yoldan girdi — ekran bunu ROZET olarak gösterebilir. */
        kaynak: zod_1.z.enum(['bahce', 'atama']),
        ekipmanlar: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string().min(1) })),
    })),
});
/** P4 — sayfalanmış kayıt listesi (Tur 3 / F3); `toplam` HER ZAMAN döner. */
exports.formSubmissionListSchema = zod_1.z.object({
    satirlar: zod_1.z.array(exports.formSubmissionSummarySchema),
    toplam: zod_1.z.number().int().nonnegative(),
    sayfa: zod_1.z.number().int().positive(),
    sayfaBoyutu: zod_1.z.number().int().positive(),
});
exports.formSubmissionDetailSchema = exports.formSubmissionSummarySchema.extend({
    sema: zod_1.z.unknown(),
    /** G1 — `notMetni`: maddenin cevabının YANINDAKİ not (cevapsız da olabilir). */
    cevaplar: zod_1.z.array(zod_1.z.object({
        alanKodu: zod_1.z.string().min(1),
        deger: zod_1.z.unknown(),
        notMetni: zod_1.z.string().nullable(),
        /** K-D1 — alanda "Diğer" seçiliyse serbest metni; aksi hâlde `null`. */
        digerMetni: zod_1.z.string().nullable(),
    })),
    ekler: zod_1.z.array(exports.formSubmissionAttachmentSchema),
    acilanAksiyonSayisi: zod_1.z.number().int().nonnegative(),
    /** F2 — düğme görünürlüğü SUNUCUDAN (S4 deseni; §2.40'ın görünürlük kolu). */
    yetkiler: zod_1.z.object({
        duzenleyebilir: zod_1.z.boolean(),
        gonderebilir: zod_1.z.boolean(),
        aksiyonAcabilir: zod_1.z.boolean(),
    }),
    /** Ş4/Ş5 — kontrol maddelerinin SAYIMI (türetilir; kural DEĞİL). */
    kontrolOzeti: zod_1.z.object({
        toplam: zod_1.z.number().int().nonnegative(),
        beklenen: zod_1.z.number().int().nonnegative(),
        olumlu: zod_1.z.number().int().nonnegative(),
        olumsuz: zod_1.z.number().int().nonnegative(),
        kapsamDisi: zod_1.z.number().int().nonnegative(),
        cevapsiz: zod_1.z.number().int().nonnegative(),
        uygunsuzlar: zod_1.z.array(zod_1.z.object({
            alanKodu: zod_1.z.string().min(1),
            etiket: zod_1.z.string().min(1),
            cevapEtiketi: zod_1.z.string().min(1),
            /** Saha turu / S5 — maddenin atfı (bulgu seçiminde taşınır). */
            atif: zod_1.z.string().nullable(),
        })),
    }),
});
/**
 * Kayıt açma. `templateVersionId` GİRDİDE YOK — sunucu şablonun YAYINLI
 * sürümünü bağlar (istemcinin sürüm seçmesi, eski sürüme kayıt açtırırdı).
 * `taslak` true ise zorunluluk denetimi ertelenir (§22.5/3 — zorunlu dosya
 * alanı kayıt satırı doğmadan yüklenemez).
 */
exports.formSubmissionCreateSchema = zod_1.z
    .object({
    formTemplateId: zod_1.z.uuid(),
    /** ✏️ T3 — görevden açılan kayıtta VERİLMEZ (görevden türetilir); aksi hâlde zorunlu. */
    workplaceId: zod_1.z.uuid().optional(),
    locationNodeId: zod_1.z.uuid().nullable().optional(),
    doldurmaTarihi: zod_1.z.iso.date(),
    cevaplar: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).default({}),
    /** G1 — madde notları (alan kodu → metin); boş metin = not yok. */
    notlar: zod_1.z.record(zod_1.z.string(), zod_1.z.string().nullable()).default({}),
    /**
     * K-D1 (28.09.2026 — Kapsam §19/13) — "Diğer" metinleri (alan kodu →
     * metin). "Diğer" seçili alanda ZORUNLU (taslakta da); seçili olmayan
     * alanda gönderilirse 422 — doğrulama `dogrulaFormCevaplari`de.
     */
    digerMetinleri: zod_1.z.record(zod_1.z.string(), zod_1.z.string().nullable()).default({}),
    taslak: zod_1.z.boolean().default(false),
    /**
     * F3·S6 — İZİN BAĞI (Kapsam §16.7.4/3-4): dolu ise kayıt bir iş izninin TÜR
     * ŞABLONUNU doldurur. **DOLDURMA İÇİN YENİ UÇ AÇILMADI**: PTW tür formu da
     * form motorunun kendi uçlarından geçer — zorunluluk, sürüm kilidi ve ek
     * kuralları bir kez yazılır. Uç, bağın tutarlılığını (şablon o türün mü,
     * izin okunabilir mi, işyeri iznin işyeri mi) ayrıca denetler.
     */
    ptwPermitId: zod_1.z.uuid().nullable().optional(),
    /**
     * Tur 3 (F1) — KONTROL EDİLEN EKİPMAN. Dolu ise gönderim o ekipmanın açık
     * görevlerini kapatır; boşsa nesne işyerinin kendisidir (§22.6a/Z2).
     * Ekipmanın kaydın işyerinde ve AKTİF olması uçta doğrulanır.
     */
    ekipmanId: zod_1.z.uuid().nullable().optional(),
    /**
     * SAHA TURU / S2 (Kapsam §27) — KAP BAĞI. Dolu ise kayıt bir denetim
     * oturumunun formudur. **YENİ UÇ AÇILMADI** (izin bağının aynısı): uç,
     * turun açık · `denetim` tipli · şablonu eşleşen · işyeri eşleşen olduğunu
     * doğrular. Tur başına TEK gönderim (kısmi unique). Görev kapanışı (Z2)
     * değişmez.
     */
    siteTourId: zod_1.z.uuid().nullable().optional(),
    /**
     * T3 (türetme paketi — bulgu 93, 17.09.2026; Kapsam §14 T3): GÖREVDEN
     * AÇILAN KAYIT. Görev hangi nesne için olduğunu bilir — işyeri ve ekipman
     * SUNUCUDA görevden türetilir, ikinci kez SORULMAZ (gömülü kayıt üst kaydın
     * verdiği alanı tekrar sormaz). Kayıt görevi SAKLAMAZ: kapanış eşleşmesi
     * aynen şablon + nesne (§22.6a/Z2).
     */
    taskOccurrenceId: zod_1.z.uuid().optional(),
})
    .superRefine((g, ctx) => {
    if (g.taskOccurrenceId) {
        // Görevin verdiği alan gövdede ikinci kez gelirse iki cevap doğar.
        for (const alan of ['workplaceId', 'ekipmanId', 'ptwPermitId', 'siteTourId']) {
            if (g[alan] != null) {
                ctx.addIssue({
                    code: 'custom',
                    path: [alan],
                    message: exports.FORM_GOREV_TURETILIR_MESAJI,
                });
            }
        }
    }
    else if (!g.workplaceId) {
        ctx.addIssue({ code: 'custom', path: ['workplaceId'], message: 'İşyeri seçin' });
    }
});
/** T3 — görevden açılan kayıtta işyeri/ekipman gövdede gelirse (D2 dili). */
exports.FORM_GOREV_TURETILIR_MESAJI = 'Görevden açılan formda işyeri ve ekipman görevden gelir — ayrıca gönderilmez';
/** Taslak kaydın cevaplarını güncelleme (gönderilmiş kayıtta 409). */
exports.formSubmissionUpdateSchema = zod_1.z.object({
    doldurmaTarihi: zod_1.z.iso.date().optional(),
    locationNodeId: zod_1.z.uuid().nullable().optional(),
    /** Tur 3 (F1) — taslakta ekipman değiştirilebilir; gönderimde kilitlenir. */
    ekipmanId: zod_1.z.uuid().nullable().optional(),
    cevaplar: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
    /**
     * G1 — madde notları. ⚠️ **GÖVDE NOTLARIN TAMAMIDIR** (cevaplarla aynı
     * sözleşme): gönderilmeyen not SİLİNİR. Kısmi güncelleme, kullanıcının
     * sildiği notu kayıtta bırakırdı.
     */
    notlar: zod_1.z.record(zod_1.z.string(), zod_1.z.string().nullable()).default({}),
    /** K-D1 — "Diğer" metinleri; notlarla AYNI sözleşme (gövde tamamıdır). */
    digerMetinleri: zod_1.z.record(zod_1.z.string(), zod_1.z.string().nullable()).default({}),
});
/**
 * Kayıttan aksiyon açma (Kapsam §22.5/7): işyeri ve kaynak sözlüğü kalemi
 * KAYITTAN türetilir — gövdede yoktur (elle girilen kaynak bağı sessizce
 * yanlış olurdu; tehlike_sinifi deseni).
 */
exports.formSubmissionActionCreateSchema = exports.actionCreateSchema.omit({
    workplaceId: true,
    kaynakTipiId: true,
    incidentId: true,
    incidentCauseId: true,
});
// ✏️ SÖKÜLDÜ (Tur 2½a — Kapsam §24.1/10, U10): `formSubmissionRequestCreateSchema`.
// Formdan-talep ucu bir ÇELİŞKİYDİ — §24/5 KPI kararı checklist/form
// bulgularını uygunsuzluk sayımının dışında tutar, o uç ise tam olarak form
// bulgusundan uygunsuzluk kaydı doğuruyordu. Form → DÖF yolu
// (`formSubmissionActionCreateSchema`) AYNEN çalışır.
exports.systemHealthSchema = zod_1.z.object({
    status: zod_1.z.enum(['ok', 'degraded']),
    service: zod_1.z.string().min(1),
    version: zod_1.z.string().min(1),
    environment: zod_1.z.enum(['development', 'test', 'production']),
    timestamp: zod_1.z.iso.datetime(),
    uptimeSeconds: zod_1.z.number().nonnegative(),
    dependencies: zod_1.z.object({
        database: exports.dependencyStateSchema,
        redis: exports.dependencyStateSchema,
        keycloak: exports.dependencyStateSchema,
    }),
});
exports.contractsAreInSync = true;
exports.identityContractIsInSync = true;
exports.tenantContractIsInSync = true;
exports.companyContractIsInSync = true;
exports.workplaceContractIsInSync = true;
exports.locationNodeContractIsInSync = true;
exports.personContractIsInSync = true;
exports.employmentContractIsInSync = true;
exports.personCompetencyContractIsInSync = true;
exports.lookupItemContractIsInSync = true;
exports.equipmentContractIsInSync = true;
exports.equipmentListContractIsInSync = true;
exports.personListContractIsInSync = true;
exports.equipmentInspectionContractIsInSync = true;
exports.contractorContractIsInSync = true;
exports.contractorListContractIsInSync = true;
exports.contractorDocumentAttachmentContractIsInSync = true;
exports.contractorPersonelContractIsInSync = true;
exports.contractorEkipmanContractIsInSync = true;
exports.contractorDocumentContractIsInSync = true;
exports.personImportReportContractIsInSync = true;
exports.pendingUserContractIsInSync = true;
exports.selectablePersonnelContractIsInSync = true;
exports.roleScopeContractIsInSync = true;
exports.roleAssignmentContractIsInSync = true;
exports.appUserScopeContractIsInSync = true;
exports.appUserRoleContractIsInSync = true;
exports.appUserSummaryContractIsInSync = true;
exports.myAuthorizationContractIsInSync = true;
exports.representativeAccountInviteContractIsInSync = true;
exports.notificationDailyRunContractIsInSync = true;
exports.kvkkAydinlatmaContractIsInSync = true;
exports.kvkkConsentResultContractIsInSync = true;
exports.actionContractIsInSync = true;
exports.nonconformityContractIsInSync = true;
exports.assignableUserContractIsInSync = true;
exports.actionAttachmentContractIsInSync = true;
exports.tenantSettingsContractIsInSync = true;
exports.notificationBellContractIsInSync = true;
exports.notificationReadResultContractIsInSync = true;
exports.formTemplateContractIsInSync = true;
exports.formTemplateVersionContractIsInSync = true;
exports.formSubmissionContractIsInSync = true;
exports.formSubmissionAttachmentContractIsInSync = true;
/**
 * Form motorunun şema kuralları ayrı dosyada (F2·S4) — dinamik şema kurucusu
 * ve şablon düzenleme kapısı burada değil `form-schema.ts`te yaşar; bu dosya
 * yalnızca API sözleşmelerini taşır.
 */
__exportStar(require("./form-schema"), exports);
__exportStar(require("./form-import"), exports);
__exportStar(require("./ptw"), exports);
__exportStar(require("./incident"), exports);
__exportStar(require("./nonconformity"), exports);
__exportStar(require("./tenant-settings"), exports);
__exportStar(require("./egitim"), exports);
__exportStar(require("./saglik"), exports);
__exportStar(require("./risk"), exports);
__exportStar(require("./gorev"), exports);
__exportStar(require("./yuzey"), exports);
__exportStar(require("./yukumluluk"), exports);
__exportStar(require("./yetki"), exports);
__exportStar(require("./gorevlendirme"), exports);
__exportStar(require("./sozluk"), exports);
__exportStar(require("./modul-rolleri"), exports);
__exportStar(require("./ikincil-okuma"), exports);
__exportStar(require("./saha-turu"), exports);
__exportStar(require("./kurul"), exports);
__exportStar(require("./kontrollu-belge"), exports);
__exportStar(require("./acil-durum"), exports);
__exportStar(require("./vade"), exports);
__exportStar(require("./dokuman"), exports);
__exportStar(require("./kpi"), exports);
__exportStar(require("./kkd"), exports);
__exportStar(require("./kapi-durumu"), exports);
__exportStar(require("./ptw-kontrol-matrisi"), exports);
// ── EKSİK KAYIT LİSTELERİ (F4·S1 — Kapsam §22.2/9 + §20.5) ──────────────────
//
// Günlük özet SAYI gönderir (Y1 — gürültü bildirimin kendisini öldürür);
// SATIRI bu uçlar açar. Okuma yetkisi KAYNAK MODÜLÜNKİYLE AYNIDIR — ikinci
// bir liste/anahtar açılmaz: temel İSG → eğitim okuma kuralı · sağlık
// kanaati → DAR okuma listesi (§16.11/10) · risk → genel GET kuralı.
/** Kaydı olmayan kişi satırı. **Kimlik no / doğum tarihi TAŞIMAZ** — bu bir
 *  eksik listesidir, kimlik yüzeyi değil (madde 37 sınırı burada da geçerli). */
exports.eksikKisiSchema = zod_1.z.strictObject({
    personId: zod_1.z.uuid(),
    adSoyad: zod_1.z.string().min(1),
    isverenAd: zod_1.z.string().min(1),
});
/** Yayınlanmış risk değerlendirmesi olmayan işyeri satırı. */
exports.eksikIsyeriSchema = zod_1.z.strictObject({
    workplaceId: zod_1.z.uuid(),
    ad: zod_1.z.string().min(1),
    companyAd: zod_1.z.string().min(1),
});
__exportStar(require("./contractor"), exports);
__exportStar(require("./api-hata"), exports);
__exportStar(require("./kisi-eksik"), exports);
__exportStar(require("./bildirim-hedef"), exports);
//# sourceMappingURL=index.js.map